/* Wave 3D Object Viewer v 1.0
 *
 */

import $ from 'jquery';
import * as THREE from 'three';
import './ColladaLoader';
import './MTLLoader';
import './OBJLoader';
import t from '../../i18n/I18n';

$.fn.wave3DViewer = function(options) {
  /* options available to user */
  this.playerSettings = $.extend(
    {
      width: 1920,
      height: 1080,
      ratio: 16 / 9,
      framerate: 29.97,
      startTime: 0,
      duration: 0,
      volume: 1,
      playbackSpeed: 1,
      loop: false,
      file: '',
      fileType: '',
      fileMaterial: '',
      quality: 'HD',
      isVR: false,
      vrMode: 'none',
      autostart: true,
      alwaysShowControls: false,
      showTitleSafe: false,
      enableComments: false,
      commentsClickFallback: null,
      playbackErrorStr: t('VIDEO_PLAYER.3DOBJECT_PLAYBACK_ERROR'),
      keyMsgStr: t('VIDEO_PLAYER.3DOBJECT_KEY_MSG'),
      commentMsgStr: t('VIDEO_PLAYER.3DOBJECT_COMMENT_MSG'),
      isCompareMode: false
    },
    options
  );

  /* internal settings */
  this.config = {};
  this.config = $.extend(
    {
      videoObject: null,
      isAudio: false,
      maxSpeed: 4,
      maxSlow: 0.25,
      maxBackwards: -4,
      animationLength: 250,
      userAgent: '',
      userAgentVersion: 0,
      isFullscreen: false,
      isSeeking: false,
      crossOrigin: 'use-credentials',
      VR_VIEW_FLAT: 'flat',
      VR_VIEW_SPHERICAL: 'spherical',
      VR_VIEW_LEFT_SPHERICAL: 'left_spherical',
      VR_VIEW_RIGHT_SPHERICAL: 'right_spherical',
      VR_MODE_NONE: 'none',
      VR_MODE_MONOSCOPIC: 'monoscopic',
      VR_MODE_OVERUNDER: 'overunder',
      VR_MODE_SIDEBYSIDE: 'sidebyside',
      curVRView: 'none',
      enableVR: true,
      curLat: 0,
      curLon: 0,
      fov: 35,
      fovMin: 3,
      fovMax: 100,
      flatProjection: false,
      threeJSObj: {},
      videoCanvasHeight: 450,
      audioCanvasHeight: 200,
      vrCanvasWidth: 1280,
      vrCanvasHeight: 720,
      vrVideoWidth: 1920,
      vrVideoHeight: 1080,
      vrCameraAnimationLength: 1000,
      comments: [],
      curComment: null,
      commentsVisible: false,
      /*  commentColorOptions: ["#e64d3d", "#e6943d", "#e6d83d", "#51e63d", "#3dd8e6", "#3d7de6", "#a83de6" ], */
      commentColorOptions: ['#ff2424', '#ff9c27', '#ffff00', '#00ff00', '#00ffff', '#0072ff', '#ff00ff'],
      commentColor: 0,
      enableFullscreen:
        typeof document.requestFullScreen == 'function' ||
        typeof document.requestFullscreen == 'function' ||
        typeof document.webkitRequestFullscreen == 'function' ||
        typeof document.webkitRequestFullScreen == 'function' ||
        typeof document.mozRequestFullScreen == 'function' ||
        typeof document.msRequestFullscreen == 'function',
      isTouch:
        'ontouchstart' in window ||
        navigator.userAgent.match(/Windows Phone/i) ||
        navigator.userAgent.match(/IEMobile/i),
      isiOS: navigator.userAgent.match(/(iPhone|iPod|iPad)/gi),
      isiPad: navigator.userAgent.match(/(iPad)/gi),
      isIE: false,
      isIEMobile: navigator.userAgent.match(/Windows Phone/i) || navigator.userAgent.match(/IEMobile/i)
    },
    this.config
  );

  var obj = this;
  var videoPlayer, key_message;
  var isDraggingTimePosition = false,
    timeOfDragStart = 0,
    timeOfLastDragUpdate = 0,
    dragUpdateInterval = 100,
    dragRefreshTimeout;
  var mouseOverTimeout, progressMouseoverTimeout;
  var originalTime;
  var isDrawingOnCanvas = false,
    lastCursorPos = {},
    canvasContext;
  var isDraggingVolume = false;
  var isGrabbingVR = false;
  var timeMouseOver, timeMouseOverLine;
  var commentToPop = '',
    commentToPopTime = 0;
  var errorOnHD = false,
    errorOnSD = false;
  var curQuality,
    canDoHD = false,
    canDoSD = false,
    canDoAudio = false;
  var commentInEdit = {
    xPos: 0,
    yPos: 0,
    lat: 0,
    lon: 0,
    vrView: 'none',
    time: 0,
    color: obj.config.commentColor,
    dot: null,
    isDot: false,
    drawingBase64: '',
    drawingPath: '',
    isDrawing: false,
    drawingImg: null,
    progressDot: null,
    isEditing: true
  };

  var ResizeComments,
    isPlayingBackward,
    ConvertSecondsToSMPTE = $.noop;

  if (obj.config.isTouch) {
    obj.playerSettings.alwaysShowControls = true;
    obj.playerSettings.quality = 'SD';
  }

  if (
    obj.playerSettings.vrMode == obj.config.VR_MODE_MONOSCOPIC ||
    obj.playerSettings.vrMode == obj.config.VR_MODE_OVERUNDER ||
    obj.playerSettings.vrMode == obj.config.VR_MODE_SIDEBYSIDE
  ) {
    obj.playerSettings.isVR = true;
  } else {
    obj.playerSettings.isVR = false;
    obj.playerSettings.vrMode = obj.config.VR_MODE_NONE;
  }

  this.CanPlayFile = function(ext) {
    var ext_string = String(ext).toLowerCase();
    if (
      ext_string == 'dae' ||
      ext_string == 'fbx' ||
      ext_string == 'gltf' ||
      ext_string == 'md2' ||
      ext_string == 'obj' ||
      ext_string == 'stl'
    ) {
      return true;
    } else {
      return false;
    }
  };
  /*
		this.TogglePause = function () {
			if(isPlayingBackward){	obj.Pause(); return false; }
			if(videoPlayer){
				obj.SetSpeed(1);
				if (videoPlayer.paused || videoPlayer.ended) {
					obj.Play();
				} else {
					obj.Pause();
				}
			}
		};
		this.isPaused = function () {
			if(videoPlayer){
				return videoPlayer.paused || videoPlayer.ended;
			}
		};
		this.Pause = function () {
			clearTimeout(intervalRewind);
			isPlayingBackward = false;
			if(videoPlayer && typeof videoPlayer.pause == 'function'){
      $(".waveplayer_container .playback_play_pause").addClass("paused");
				videoPlayer.pause();
				ShowCommentsAtCurrentTime();
				obj.SetSpeed(1);
			}
		};
		this.Play = function () {
			if(isPlayingBackward){	obj.Pause(); }
			if(videoPlayer && typeof videoPlayer.play == 'function'){
      $(".waveplayer_container .playback_play_pause").removeClass("paused");
				obj.HideComments();
				videoPlayer.play();
			}
		};
		this.PlayWhenReady = function(){
			if(!obj.config.isTouch){
				if (videoPlayer){
					if(videoPlayer.readyState > videoPlayer.HAVE_CURRENT_DATA){
						obj.Play();
					} else {
						videoPlayer.addEventListener('loadeddata', obj.Play);
					}
				} else {
					obj.playerSettings.autostart = true;
				}
			}
		};
		this.ToggleMute = function (mute) {
			if(videoPlayer){
				if(typeof mute == 'undefined'){
					mute = !videoPlayer.muted;
				}
	
				videoPlayer.muted = mute;
				UpdateVolumeSlider();
			}
		};
		this.SetVolume = function(newVol){
			if(videoPlayer){
				newVol = parseFloat(newVol) || 1;
	
				if(newVol < 0){
					newVol = 0;
				}
				if(newVol > 1){
					newVol = 1;
				}
	
				videoPlayer.volume = obj.playerSettings.volume = newVol;
	
				if(obj.playerSettings.volume == 0){
					obj.ToggleMute(true);
				} else {
					obj.ToggleMute(false);
				}
			}
		};
		UpdateVolumeSlider = function(){
			if(videoPlayer){
      $(".waveplayer_container .playback_volume").removeClass("muted low med");
				if(videoPlayer.muted || obj.playerSettings.volume == 0){
        $(".waveplayer_container .playback_volume").addClass("muted");
        $(".waveplayer .volume_slider").height(0 + "%");
				} else {
        $(".waveplayer .volume_slider").height(obj.playerSettings.volume*100 + "%");
					if(obj.playerSettings.volume <= 0.33){
          $(".waveplayer_container .playback_volume").addClass("low");
					} else if(obj.playerSettings.volume <= 0.66){
          $(".waveplayer_container .playback_volume").addClass("med");
					}
				}
			}
	
		};
		this.ToggleLoop = function () {
			if(videoPlayer){
				videoPlayer.loop = !videoPlayer.loop;
	
				if(videoPlayer.loop){
        $(".waveplayer_container .playback_loop").addClass("active");
				} else {
        $(".waveplayer_container .playback_loop").removeClass("active");
				}
			}
		};
		this.GoToTime = function (time) {
			clearTimeout(intervalRewind);
			if(typeof ClearCommentBorders == 'function'){
				ClearCommentBorders();
			}
			if(videoPlayer){
				//obj.Pause();
				time = parseFloat(time) || 0;
	
				var duration = videoPlayer.duration;
	
      $(".waveplayer_container .progress_playback, .waveplayer_container .audio_line").addClass("no_animate");
	
				if(time < 0){
        $(".waveplayer_container .progress_playback").css("width", 0 + "%");
					videoPlayer.currentTime = 0;
				} else if(time > videoPlayer.duration){
        $(".waveplayer_container .progress_playback").css("width", 100 + "%");
					videoPlayer.currentTime = videoPlayer.duration;
				} else {
					if(duration > 0){
          $(".waveplayer_container .progress_playback").css("width", time/duration*100 + "%");
					}
					videoPlayer.currentTime = time;
				}
				obj.CancelNewComment();
				ClearCommentCanvas();
				if(!commentToPop && obj.isPaused()){
					ShowCommentsAtCurrentTime();
				}
			}
		};
		*/
  this.GoToTimeAndPopComment = function(time, uniqueID, lat, lon, vrView) {
    //	if(videoPlayer){
    commentToPop = uniqueID;
    commentToPopTime = time;
    obj.CancelNewComment();
    obj.HideComments();
    //		obj.Pause();
    //		obj.GoToTime(time);

    //		if(obj.playerSettings.isVR){
    VRAnimateCamera(lat, lon);
    //			if(obj.config.curVRView != obj.config.VR_VIEW_FLAT && obj.config.enableVR){
    //				SetVRView(vrView, true);
    //			}
    //		}
    //	}
  };
  /*
		this.GetCurrentTime = function(){
			return 0;
		};*/
  /*
		this.SpeedUp = function () {
			if(videoPlayer){
				if(isPlayingBackward){
					if(obj.playerSettings.playbackSpeed < -1){
						obj.playerSettings.playbackSpeed = obj.playerSettings.playbackSpeed * 0.5;
					} else {
						obj.Pause();
          obj.ShowMessage("<div class='pause_black'></div>");
					}
					return false;
				}
	
				if(obj.playerSettings.playbackSpeed < obj.config.maxSpeed){
					videoPlayer.playbackRate = obj.playerSettings.playbackSpeed = obj.playerSettings.playbackSpeed * 2;
				}
			}
		};
		this.SlowDown = function () {
			if(isPlayingBackward){	obj.Pause(); return false; }
			if(videoPlayer){
				if(obj.playerSettings.playbackSpeed > obj.config.maxSlow){
					videoPlayer.playbackRate = obj.playerSettings.playbackSpeed = obj.playerSettings.playbackSpeed * 0.5;
				}
			}
		};
	
		var intervalRewind, timeSinceLastRewind, intervalLength, isPlayingBackward = false;
		this.PlayBackwards = function () {
			if(videoPlayer){
      $(".waveplayer_container .playback_play_pause").removeClass("paused");
				isPlayingBackward = true;
	
				if(obj.playerSettings.playbackSpeed >= 0){
					obj.playerSettings.playbackSpeed = -1;
				} else if(obj.playerSettings.playbackSpeed > obj.config.maxBackwards){
					obj.playerSettings.playbackSpeed = obj.playerSettings.playbackSpeed * 2;
				}
	
				intervalLength = 1 / 30 * 1000;
	
				videoPlayer.playbackRate = 1.0;
	
				timeSinceLastRewind = new Date().getTime();
				clearTimeout(intervalRewind);
				obj.GoBackward();
	
			}
		};
	
		this.GoBackward = function(){
			clearTimeout(intervalRewind);
			if(videoPlayer){
				intervalRewind = setTimeout(function(){
					var curTime = new Date().getTime();
					var timeDiff = (curTime - timeSinceLastRewind) / 1000;
					timeSinceLastRewind = curTime;
	
					if(videoPlayer.currentTime <= 0 || videoPlayer.currentTime + timeDiff * obj.playerSettings.playbackSpeed <= 0){
						clearTimeout(intervalRewind);
						videoPlayer.currentTime = 0;
						obj.Pause();
					} else {
						videoPlayer.currentTime += timeDiff * obj.playerSettings.playbackSpeed;
						obj.GoBackward();
					}
	
				}, intervalLength);
			}
		};
	
	
	
	
		this.SetSpeed = function (newSpeed) {
			if(videoPlayer){
				if(newSpeed < obj.config.maxSpeed && newSpeed > obj.config.maxBackwards){
					obj.playerSettings.playbackSpeed = parseFloat(newSpeed) || 1;
				} else {
					obj.playerSettings.playbackSpeed = 1;
				}
				videoPlayer.playbackRate = obj.playerSettings.playbackSpeed;
			}
		};
	*/

  var systemMessageTimeout;
  this.ShowMessage = function(msg) {
    if (!$('.waveplayer_container').hasClass('audio') || $('.waveplayer_container').hasClass('waveform')) {
      clearTimeout(systemMessageTimeout);
      $('.system_message')
        .removeClass('visible')
        .html(msg)
        .css('left', $('.controls').width() * 0.5 - $('.system_message').outerWidth() * 0.5)
        .addClass('visible');

      systemMessageTimeout = setTimeout(function() {
        $('.system_message').removeClass('visible');
      }, 1000);
    }
  };

  this.ToggleTitleSafe = function(newVal) {
    if (typeof newVal == 'undefined') {
      newVal = !$('.waveplayer_container .playback_title_safe').hasClass('active');
    }

    if (newVal) {
      //  $(".waveplayer_container .title_safe").show();
      $('.waveplayer_container .playback_title_safe').addClass('active');
      obj.config.threeJSObj.grid.visible = true;
      //obj.playerSettings.showTitleSafe = true;
    } else {
      //  $(".waveplayer_container .title_safe").hide();
      $('.waveplayer_container .playback_title_safe').removeClass('active');
      obj.config.threeJSObj.grid.visible = false;
      //obj.playerSettings.showTitleSafe = false;
    }
  };

  this.ShowComments = function(enable) {
    if (typeof enable == 'undefined') {
      enable = !$('.waveplayer_container').hasClass('enable_comments');
    }

    obj.config.commentsVisible = enable;

    if (enable) {
      obj.ShowControls(true);
      $('.waveplayer_container').addClass('enable_comments');
      //	if(!obj.playerSettings.isVR){
      //    $('.waveplayer_container .comment_point').addClass("active");
      //    $(".waveplayer_container").addClass("cursor_comment_point").removeClass("cursor_comment_paint");
      //    $(".waveplayer_container .hand_icon").removeClass("active").hide();
      //	} else {
      $('.waveplayer_container .hand_icon')
        .addClass('active')
        .show();
      $('.waveplayer_container .comment_point, .waveplayer_container .comment_paint').removeClass('active');
      $('.waveplayer_container')
        .removeClass('cursor_comment_point')
        .removeClass('cursor_comment_paint');
      //	}
      ShowCommentsAtCurrentTime();
    } else {
      obj.ShowControls(obj.playerSettings.alwaysShowControls);

      $('.waveplayer_container .hand_icon')
        .addClass('active')
        .show();
      $('.waveplayer_container .comment_point, .waveplayer_container .comment_paint').removeClass('active');

      $('.waveplayer_container')
        .removeClass('enable_comments')
        .removeClass('cursor_comment_point')
        .removeClass('cursor_comment_paint');
      ClearCommentCanvas();
      obj.CancelNewComment();
    }
    obj.HandleResize();
  };

  this.ShowControls = function(show) {
    if (typeof show == 'undefined') {
      show = !$('.waveplayer_container .controls').hasClass('always_visible');
    }

    if (show) {
      $('.waveplayer_container .controls').addClass('always_visible');
      $('.waveplayer_container').addClass('controls_always_visible');
    } else {
      $('.waveplayer_container')
        .removeClass('enable_comments')
        .removeClass('cursor_comment_point')
        .removeClass('cursor_comment_paint');

      $('.waveplayer_container .controls').removeClass('always_visible');
      $('.waveplayer_container').removeClass('controls_always_visible');
    }
    obj.HandleResize();
  };

  this.ToggleFullscreen = function(newVal) {
    var isCurrentlyFullscreen = false;
    if (
      document.fullScreen ||
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement ||
      $('.waveplayer_container').hasClass('fullscreen')
    ) {
      isCurrentlyFullscreen = true;
    }

    if (typeof newVal == 'undefined') {
      if (isCurrentlyFullscreen) {
        newVal = false;
      } else {
        newVal = true;
      }
    }

    if ((newVal && isCurrentlyFullscreen) || (!newVal && !isCurrentlyFullscreen)) {
      return false;
    }

    var wavePlayerDiv = $('.waveplayer .waveplayer_container')[0];
    if (wavePlayerDiv) {
      if (newVal) {
        /*if(obj.config.isiOS && !obj.config.isiPad){
					if(videoPlayer.webkitRequestFullscreen) videoPlayer.webkitRequestFullscreen();
					else if(videoPlayer.webkitEnterFullScreen) videoPlayer.webkitEnterFullScreen();
				} else */ if (
          wavePlayerDiv.requestFullScreen
        ) {
          wavePlayerDiv.requestFullScreen();
        } else if (wavePlayerDiv.requestFullscreen) {
          wavePlayerDiv.requestFullscreen();
        } else if (wavePlayerDiv.webkitRequestFullscreen) {
          wavePlayerDiv.webkitRequestFullscreen();
        } else if (wavePlayerDiv.webkitRequestFullScreen) {
          wavePlayerDiv.webkitRequestFullScreen();
        } else if (wavePlayerDiv.mozRequestFullScreen) {
          wavePlayerDiv.mozRequestFullScreen();
        } else if (wavePlayerDiv.msRequestFullscreen) {
          wavePlayerDiv.msRequestFullscreen();
        }

        $('.waveplayer .waveplayer_container').addClass('fullscreen');
        obj.config.isFullscreen = true;
        obj.HandleResize();
      } else {
        /*if(obj.config.isiOS && !obj.config.isiPad){
					if(videoPlayer.webkitCancelFullScreen) videoPlayer.webkitCancelFullScreen();
					else if(videoPlayer.webkitExitFullscreen) videoPlayer.webkitExitFullscreen();
				} else */ if (
          document.cancelFullScreen
        ) {
          document.cancelFullScreen();
        } else if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }

        $('.waveplayer .waveplayer_container').removeClass('fullscreen');
        obj.config.isFullscreen = false;
        obj.HandleResize();
      }
    }
  };

  var FullscreenChange = function() {
    if (
      document.fullScreen ||
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    ) {
      obj.config.isFullscreen = true;
    } else {
      obj.config.isFullscreen = false;
      $('.waveplayer .waveplayer_container').removeClass('fullscreen');
      obj.HandleResize();
      setTimeout(function() {
        obj.HandleResize();
        if (typeof ResizeComments == 'function') {
          ResizeComments();
        }
      }, 1000);
    }
  };

  var FullscreenError = function() {
    obj.config.isFullscreen = false;
    $('.waveplayer .waveplayer_container').removeClass('fullscreen');
    obj.ShowMessage('Error going fullscreen');
  };

  var PlaybackError = function() {
    $('.waveplayer .waveplayer_container').addClass('error');
    $('.waveplayer .playback_error')
      .html('<p>' + obj.playerSettings.playbackErrorStr + '</p>')
      .show();
    obj.ShowComments(false);
    obj.ShowControls(false);
    $('.waveplayer .controls, .waveplayer .media').hide();
  };

  /*
		PreloadWavePlayerImages = function(){
			var images = new Array();
			for (var i = 0; i < PreloadWavePlayerImages.arguments.length; i++) {
				images[i] = new Image();
				images[i].src = PreloadWavePlayerImages.arguments[i];
			}
		}
	*/

  var MouseMove = function(e) {
    var d = new Date();
    if (isDraggingTimePosition) {
      var progressObj = $('.waveplayer_container .progress_container');
      var pageX = e.pageX;
      if (!pageX && e.originalEvent && e.originalEvent.touches && e.originalEvent.touches.length) {
        pageX = e.originalEvent.touches[0].pageX;
      }
      var xPos = pageX - progressObj.offset().left;
      if (progressObj.width() > 0) {
        if (d.getTime() > timeOfLastDragUpdate + dragUpdateInterval) {
          timeOfLastDragUpdate = d.getTime();
          obj.Pause();
          obj.GoToTime((xPos / progressObj.width()) * videoPlayer.duration);
        } else {
          clearTimeout(dragRefreshTimeout);
          dragRefreshTimeout = setTimeout(function() {
            obj.GoToTime((xPos / progressObj.width()) * videoPlayer.duration);
          }, dragUpdateInterval);
        }
      }
    }
  };

  var MouseDraw = function(e) {
    var target = $('.waveplayer .interaction_target'); /* .comment_canvas  */
    var canvas = $('.waveplayer .comment_canvas.in_progress');
    var mousePos = GetMousePosition(e);
    var pageX = mousePos.x;
    var pageY = mousePos.y;

    if (canvas.attr('width') <= 0 || canvas.attr('height') <= 0 || target.width() <= 0 || target.height() <= 0) {
      return false;
    }

    var startX = lastCursorPos['x'],
      startY = lastCursorPos['y'],
      endX,
      endY;

    //		if(obj.playerSettings.isVR && obj.config.curVRView != obj.config.VR_VIEW_FLAT && obj.config.curVRView != obj.config.VR_MODE_NONE && obj.config.threeJSObj && obj.config.threeJSObj.camera && obj.config.threeJSObj.scene){

    //			var uv = GetUVFromMouse(pageX, pageY);

    //      endX = uv.u * canvas.attr("width");
    //      endY = uv.v * canvas.attr("height");

    //		} else {
    endX = ((pageX - target.offset().left) / target.width()) * canvas.attr('width');
    endY = ((pageY - target.offset().top) / target.height()) * canvas.attr('height');
    //		}

    if (!isDrawingOnCanvas) {
      isDrawingOnCanvas = true;

      /* so a click results in a dot (a line that's 1px long), instead of nothing */
      startX = endX - 1;
      startY = endY - 1;
    }

    /* avoid the rings made by drawing at the canvas edge. if the distance between the points is greater than half of the canvas side (average b/t width and height) then don't draw it */
    if (
      obj.playerSettings.isVR &&
      Math.sqrt((endX - startX) * (endX - startX) + (endY - startY) * (endY - startY)) > 0.25 * canvas.attr('width')
    ) {
      startX = endX - 1;
      startY = endY - 1;
      /* return false; */
      /*
			if(startX < 2) startX = 2;
      if(startX > canvas.attr("width") - 2) startX = canvas.attr("width") - 2;

			if(startY < 2) startY = 2;
      if(startY > canvas.attr("height") - 2) startY = canvas.attr("height") - 2;

			if(endX < 2) endX = 2;
      if(endX > canvas.attr("width") - 2) endX = canvas.attr("width") - 2;

			if(endY < 2) endY = 2;
      if(endY > canvas.attr("height") - 2) endY = canvas.attr("height") - 2;
			*/
    }

    /*
		if(startX == endX && startY == endY){
			startX--;
			startY--;
		}*/

    var canvasContext = $('.waveplayer .comment_canvas.in_progress')[0].getContext('2d');

    canvasContext.strokeStyle = obj.config.commentColorOptions[obj.config.commentColor];
    canvasContext.lineJoin = 'round';
    canvasContext.lineWidth = 2;
    canvasContext.beginPath();
    canvasContext.moveTo(startX, startY);
    canvasContext.lineTo(endX, endY);
    canvasContext.stroke();
    canvasContext.closePath();

    lastCursorPos = { x: endX, y: endY };
  };

  this.HandleResize = function() {
    if (obj.config.isFullscreen) {
      $('.waveplayer .waveplayer_container').height('');

      //  $(".waveplayer .media_comment_holder, .waveplayer .title_safe").width($(".waveplayer .media").width()).height($(".waveplayer .media").width() / obj.playerSettings.ratio);
      //  if($(".waveplayer .media_comment_holder").height() > $(".waveplayer .media").height()){
      //    $(".waveplayer .media_comment_holder, .waveplayer .title_safe").height($(".waveplayer .media").height());
      //    $(".waveplayer .media_comment_holder, .waveplayer .title_safe").width($(".waveplayer .media").height() * obj.playerSettings.ratio);
      //	}
      //  $(".waveplayer .media_comment_holder, .waveplayer .title_safe").css({"margin-top": ($(".waveplayer .media").height() - $(".waveplayer .media_comment_holder").height()) * 0.5, "margin-left": ($(".waveplayer .media").width() - $(".waveplayer .media_comment_holder").width()) * 0.5});
    } else if (obj.config.isAudio) {
      $('.waveplayer .waveplayer_container')
        .height('')
        .width('');
      $('.waveplayer .media_comment_holder, .waveplayer .title_safe')
        .width('')
        .height('')
        .css({ 'margin-top': '', 'margin-left': '' });
    } else {
      /*  $(".waveplayer .waveplayer_container").height($(".waveplayer").height());
      $(".waveplayer .waveplayer_container").width($(".waveplayer").width());*/
      var controlsHeight = $('.waveplayer .controls').outerHeight() - $('.waveplayer .controls').height();
      $('.waveplayer .waveplayer_container').width($('.waveplayer').width());
      $('.waveplayer .waveplayer_container').height(
        $('.waveplayer').width() / obj.playerSettings.ratio + controlsHeight
      );
      if ($('.waveplayer .waveplayer_container').height() > $('.waveplayer').height()) {
        $('.waveplayer .waveplayer_container').height($('.waveplayer').height());
        $('.waveplayer .waveplayer_container').width(
          ($('.waveplayer').height() - controlsHeight) * obj.playerSettings.ratio
        );
      }

      /* $(".waveplayer .waveplayer_container").height($(".waveplayer .waveplayer_container").width() / obj.playerSettings.ratio + $(".waveplayer .controls").outerHeight() - $(".waveplayer .controls").height()); */
      $('.waveplayer .media_comment_holder, .waveplayer .title_safe')
        .width('')
        .height('')
        .css({ 'margin-top': '', 'margin-left': '' });
    }

    if (
      obj.playerSettings.isVR &&
      obj.config.threeJSObj.renderer &&
      obj.config.threeJSObj.glCanvas &&
      obj.config.threeJSObj.camera &&
      obj.config.threeJSObj.videocanvas
    ) {
      /*obj.config.threeJSObj.videocanvas.width = obj.config.threeJSObj.glCanvas.parent().width();
			obj.config.threeJSObj.videocanvas.height = obj.config.threeJSObj.glCanvas.parent().height();*/

      /*  obj.config.threeJSObj.renderer.setSize($(".waveplayer .media_comment_holder").width(), $(".waveplayer .media_comment_holder").height()); */
      /*	if(obj.config.isFullscreen){
        obj.config.threeJSObj.glCanvas.css( { "margin-top": $(".waveplayer .media_comment_holder").css("margin-top"), "margin-left": $(".waveplayer .media_comment_holder").css("margin-left") } );
				} else {
        obj.config.threeJSObj.glCanvas.css( { "margin-top": "", "margin-left": "" } );
				}*/
      var newWidth = obj.config.threeJSObj.glCanvas.parent().width();
      var newHeight = obj.config.threeJSObj.glCanvas.parent().height();
      obj.config.threeJSObj.renderer.setSize(newWidth, newHeight, false);

      if (newHeight > 0) {
        /* $(".waveplayer .media_comment_holder").height()   */
        obj.config.threeJSObj.camera.aspect = newWidth / newHeight;
        /* $(".waveplayer .media_comment_holder").width() / $(".waveplayer .media_comment_holder").height(); */
      } else {
        obj.config.threeJSObj.camera.aspect = 16 / 9;
      }

      //			obj.config.threeJSObj.renderer.setSize(obj.config.threeJSObj.glCanvas.parent().width(), obj.config.threeJSObj.glCanvas.parent().height());
      //      obj.config.threeJSObj.glCanvas.css({"width": "", "height": ""});

      obj.config.threeJSObj.camera.updateProjectionMatrix();

      VRRender();
    }

    $('.system_message').css('left', $('.controls').width() * 0.5 - $('.system_message').outerWidth() * 0.5);
    $('.waveplayer_container .playback_seeking')
      .css('height', $('.waveplayer_container .playback_seeking').width())
      .css(
        'top',
        0.5 *
          $('.waveplayer_container .playback_seeking')
            .parent()
            .height() -
          0.5 * $('.waveplayer_container .playback_seeking').height()
      );

    var i,
      curEl,
      el = [
        '.key_message',
        '.playback_title_safe',
        '.playback_loop',
        '.playback_quality',
        '.vr_view',
        '.timecode .total_time',
        '.timecode',
        '.playback_fullscreen',
        '.playback_volume'
      ];
    for (i = 0; i < el.length; i++) {
      curEl = '.controlbar .control_button' + el[i];
      if (!$(curEl).hasClass('disabled')) {
        $(curEl).show();
      }
    }
    i = 0;
    while (i < el.length && $('.controlbar .button_container').outerWidth(true) > $('.controlbar').outerWidth(true)) {
      curEl = '.controlbar .control_button' + el[i];
      if (!$(curEl).hasClass('disabled')) {
        $(curEl).hide();
      }
      i++;
    }

    if (!$('.comment_controlbar .comment_message').hasClass('disabled')) {
      if ($('.controlbar .control_button.key_message').is(':visible')) {
        $('.comment_controlbar .comment_message').show();
      } else {
        $('.comment_controlbar .comment_message').hide();
      }
    }

    /* $(".waveplayer").css("min-height", $(".waveplayer .waveplayer_container").outerHeight()); */
  };

  this.Destroy = function() {
    if (obj.config.threeJSObj.requestAnimationId) {
      window.cancelAnimationFrame(obj.config.threeJSObj.requestAnimationId);
      obj.config.threeJSObj.requestAnimationId = '';
    }

    if (obj.config.threeJSObj && obj.config.threeJSObj.texture) {
      obj.config.threeJSObj.texture.dispose();
    }
    if (obj.config.threeJSObj && obj.config.threeJSObj.scene) {
      obj.config.threeJSObj.scene.remove(obj.config.threeJSObj.mesh);
    }

    $('.waveplayer video, .waveplayer audio, .waveplayer video source, .waveplayer audio source').off('error');

    $('.waveplayer_container').off('mouseenter mousemove mouseleave contextmenu');

    $('.waveplayer_container .progress_container').off('mouseenter mousemove');
    $('.waveplayer_container .progress_container').off('mousedown touchstart');
    $('.waveplayer .interaction_target, .waveplayer .title_safe').off('mousedown touchstart');
    $(
      '.waveplayer_container .playback_play_pause, .waveplayer_container .playback_volume, .waveplayer_container .playback_loop, .waveplayer_container .playback_title_safe, .waveplayer_container .playback_fullscreen, .waveplayer_container .comment_point, .waveplayer_container .comment_paint, .waveplayer_container .comment_clear_button, .waveplayer_container .hand_icon, .waveplayer_container .comment_color'
    ).off('click');
    $('.waveplayer_container .vr_view, .waveplayer_container .playback_quality').off('click');

    $(
      '.waveplayer_container .playback_volume, .waveplayer_container .vr_view, .waveplayer_container .playback_quality, .waveplayer_container .comment_color'
    ).off('mouseenter mouseleave');
    $(window).off('resize', obj.HandleResize);
    $(window).off('orientationchange', OrientationChangeHandler);

    $(window).off('keydown', KeydownHandler);

    document.removeEventListener('fullscreenchange', FullscreenChange);
    document.removeEventListener('webkitfullscreenchange', FullscreenChange);
    document.removeEventListener('mozfullscreenchange', FullscreenChange);
    document.removeEventListener('MSFullscreenChange', FullscreenChange);

    document.removeEventListener('fullscreenerror', FullscreenError);
    document.removeEventListener('webkitfullscreenerror', FullscreenError);
    document.removeEventListener('mozfullscreenerror', FullscreenError);
    document.removeEventListener('MSFullscreenError', FullscreenError);

    obj.config.videoObject = null;
    videoPlayer = null;

    $(
      '.waveplayer_container .media video, .waveplayer_container .media audio'
    ).remove(); /*
    }
    $(this._renderer.domElement).remove();*/

    /*if(this._isVideo) {
			this.unloadVideo();
			/* unloadVideo is:
				this.pause();
            	this._video.src = '';
              this._video.removeAttribute('src');*/
  };

  /*
		UpdateTimecodeDisplay = function(time, duration){
    $(".waveplayer .controlbar .timecode").html("<p>" + ConvertSecondsToSMPTE(time + obj.playerSettings.startTime) + "<span class='total_time'> / " + ConvertSecondsToSMPTE(duration + obj.playerSettings.startTime) + "</span></p>");
		};
	*/
  var seekingInterval, seekingTimeout, seekingStartTime, deg;
  var SeekingAnimation = function(enable) {
    if (typeof enable == 'undefined') {
      enable = !$('.waveplayer_container').hasClass('seeking');
    }

    if (enable) {
      if (!obj.config.isSeeking) {
        obj.config.isSeeking = true;

        seekingTimeout = setTimeout(function() {
          if (obj.config.isSeeking) {
            $('.waveplayer_container').addClass('seeking');
            $('.waveplayer_container .playback_seeking')
              .css('height', $('.waveplayer_container .playback_seeking').width())
              .css(
                'top',
                0.5 *
                  $('.waveplayer_container .playback_seeking')
                    .parent()
                    .height() -
                  0.5 * $('.waveplayer_container .playback_seeking').height()
              )
              .show();

            clearInterval(seekingInterval);
            seekingInterval = setInterval(function() {
              seekingStartTime = 0.55 * new Date().getTime();
              deg = parseInt(seekingStartTime - Math.floor(seekingStartTime / 360.0) * 360);

              $('.waveplayer_container .playback_seeking .spinner').css('transform', 'rotate(' + deg + 'deg)');
            }, 30);
          }
        }, 500);
      }
    } else {
      obj.config.isSeeking = false;
      clearTimeout(seekingTimeout);
      clearInterval(seekingInterval);

      $('.waveplayer_container').removeClass('seeking');
      $('.waveplayer_container .playback_seeking').hide();
      /*$(".waveplayer_container .playback_seeking .block").remove();*/
    }
  };

  var GetMousePosition = function(e) {
    var pageX = e.pageX;
    var pageY = e.pageY;
    if (!pageX && e.originalEvent && e.originalEvent.touches && e.originalEvent.touches.length) {
      pageX = e.originalEvent.touches[0].pageX;
    }
    if (!pageY && e.originalEvent && e.originalEvent.touches && e.originalEvent.touches.length) {
      pageY = e.originalEvent.touches[0].pageY;
    }

    var coord = { x: pageX, y: pageY };
    return coord;
  };

  var GetUVFromMouse = function(x, y) {
    var returnUV = {};

    var target = $('.waveplayer .interaction_target');

    var raycaster = new THREE.Raycaster();
    var mouse = new THREE.Vector2();
    var onClickPosition = new THREE.Vector2();

    var array = [(x - target.offset().left) / target.width(), (y - target.offset().top) / target.height()];
    onClickPosition.fromArray(array);

    mouse.set(onClickPosition.x * 2 - 1, -(onClickPosition.y * 2) + 1);

    raycaster.setFromCamera(mouse, obj.config.threeJSObj.camera);
    /* var intersects = raycaster.intersectObjects( obj.config.threeJSObj.scene.children ); */
    var intersects = raycaster.intersectObject(obj.config.threeJSObj.mesh);

    if (intersects.length > 0 && intersects[0].uv) {
      var uv = intersects[0].uv;
      /*intersects[ 0 ].object.material.map.transformUv( uv );  /* accounts for flip, repeat, and offset settings. they don't apply here */
      //canvas.setCrossPosition( uv.x, uv.y );*/

      if (obj.config.threeJSObj.texture) {
        uv.x = uv.x * obj.config.threeJSObj.texture.repeat.x + obj.config.threeJSObj.texture.offset.x;
        uv.y = uv.y * obj.config.threeJSObj.texture.repeat.y + obj.config.threeJSObj.texture.offset.y;
      }

      returnUV = { u: 1 - uv.x, v: 1 - uv.y };
    } else {
      returnUV = { u: -1, v: -1 };
    }

    return returnUV;
  };

  var DetectWebGLContext = function() {
    /*return false;*/

    try {
      var canvas = document.createElement('canvas');
      return !!(
        window.WebGLRenderingContext &&
        (canvas.getContext('webgl') || canvas.getContext('experimental-webgl'))
      );

      /* var gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");

			if (gl && gl instanceof WebGLRenderingContext) {
				return true;
			} else {
				return false;
			}*/
    } catch (e) {
      return null;
    }
  };

  var VRSetup = function() {
    // obj.config.threeJSObj.glCanvas = $('.waveplayer .vr_render_canvas');
    // obj.config.threeJSObj.glCanvas.show();
    $('.waveplayer .vr_render_canvas').map(function(i) {
      obj.config.threeJSObj.glCanvas = $('.waveplayer .vr_render_canvas').eq(i);
      obj.config.threeJSObj.glCanvas.show();
    });

    $('.waveplayer .waveplayer_container').addClass('is_vr');

    obj.config.threeJSObj.requestAnimationId = '';
    obj.config.threeJSObj.dragStart = {};

    if (isNaN(obj.config.threeJSObj.lat)) {
      obj.config.threeJSObj.lat = 0;
    }
    if (isNaN(obj.config.threeJSObj.lon)) {
      obj.config.threeJSObj.lon = 0;
    }

    obj.config.threeJSObj.fov = obj.config.fov;

    obj.config.threeJSObj.scene = new THREE.Scene();
    obj.config.threeJSObj.camera = new THREE.PerspectiveCamera(
      obj.config.fov,
      obj.config.threeJSObj.glCanvas.parent().width() / obj.config.threeJSObj.glCanvas.parent().height(),
      0.1,
      1000
    );
    obj.config.threeJSObj.cameraStartingDistance = 2.5;
    obj.config.threeJSObj.camera.position.set(0, 0, obj.config.threeJSObj.cameraStartingDistance);
    obj.config.threeJSObj.camera.lookAt(obj.config.threeJSObj.scene.position);

    obj.config.threeJSObj.keyLight = new THREE.DirectionalLight(new THREE.Color('hsl(30, 100%, 75%)'), 0.85);
    obj.config.threeJSObj.keyLight.position.set(-100, 0, 100);

    obj.config.threeJSObj.fillLight = new THREE.DirectionalLight(new THREE.Color('hsl(240, 100%, 75%)'), 0.65);
    obj.config.threeJSObj.fillLight.position.set(100, 0, 100);

    obj.config.threeJSObj.backLight = new THREE.DirectionalLight(0xffffff, 0.75);
    obj.config.threeJSObj.backLight.position.set(100, 0, -100).normalize();

    obj.config.threeJSObj.scene.add(obj.config.threeJSObj.keyLight);
    obj.config.threeJSObj.scene.add(obj.config.threeJSObj.fillLight);
    obj.config.threeJSObj.scene.add(obj.config.threeJSObj.backLight);

    obj.config.threeJSObj.scene.background = new THREE.Color('rgb(200, 200, 200)');
    obj.config.threeJSObj.scene.fog = new THREE.Fog('rgb(200, 200, 200)', 200, 1000);

    //  var mesh = new THREE.Mesh( new THREE.PlaneBufferGeometry( 2000, 2000 ), new THREE.MeshPhongMaterial( { color: "rgb(200, 200, 200)", depthWrite: false } ) );
    //	mesh.rotation.x = - Math.PI / 2;
    //	mesh.receiveShadow = true;
    //	obj.config.threeJSObj.scene.add( mesh );

    obj.config.threeJSObj.grid = new THREE.GridHelper(20, 20, 'rgb(0, 0, 0)', 'rgb(0, 0, 0)');
    obj.config.threeJSObj.grid.material.opacity = 0.2;
    obj.config.threeJSObj.grid.material.transparent = true;
    obj.config.threeJSObj.scene.add(obj.config.threeJSObj.grid);

    /*obj.config.threeJSObj.renderer = new THREE.WebGLRenderer();*/
    obj.config.threeJSObj.renderer = DetectWebGLContext()
      ? new THREE.WebGLRenderer({ canvas: obj.config.threeJSObj.glCanvas[0], antialias: true })
      : new THREE.CanvasRenderer({ canvas: obj.config.threeJSObj.glCanvas[0] });
    //		obj.config.threeJSObj.renderer.setSize( obj.config.threeJSObj.glCanvas.parent().width(), obj.config.threeJSObj.glCanvas.parent().height(), false);
    obj.config.threeJSObj.renderer.setSize(obj.config.vrCanvasWidth, obj.config.vrCanvasHeight, false);
    obj.config.threeJSObj.renderer.autoClear = false;
    obj.config.threeJSObj.renderer.setClearColor(0x333333, 1);

    //	obj.config.threeJSObj.texture = new THREE.Texture(obj.config.threeJSObj.videocanvas, THREE.UVMapping);
    //	obj.config.threeJSObj.texture.offset.set(0, 0);
    //	obj.config.threeJSObj.texture.repeat.set(1, 1);

    //	obj.config.threeJSObj.texture.generateMipmaps = false;
    //	obj.config.threeJSObj.texture.minFilter = THREE.LinearFilter;
    //	obj.config.threeJSObj.texture.magFilter = THREE.LinearFilter;
    //	obj.config.threeJSObj.texture.format = THREE.RGBFormat;

    //		var geometry = new THREE.BoxGeometry( 5, 5, 5);
    //		var material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
    //		var cube = new THREE.Mesh( geometry, material );
    //		obj.config.threeJSObj.scene.add( cube );

    if (obj.playerSettings.fileType == 'obj') {
      var loader = new THREE.OBJLoader();
      loader.load(
        obj.playerSettings.file,
        function(object) {
          obj.config.threeJSObj.object = object; //object.children[0];
          obj.config.threeJSObj.scene.add(obj.config.threeJSObj.object);

          /*		if(obj.playerSettings.fileMaterial != ""){
							var MTLloader = new THREE.MTLLoader();
							MTLloader.load(obj.playerSettings.fileMaterial, function(material){
								obj.config.threeJSObj.object.traverse( function ( child ) {
											if ( child instanceof THREE.Mesh ) {
													child.material = material;
											}
									});
								ScaleObjectToView(obj.config.threeJSObj.object);
							});
	
						} else { */
          ScaleObjectToView(obj.config.threeJSObj.object);
          /*		} */
        },
        function(xhr) {
          // called when loading is in progresses
          //	console.log( ( xhr.loaded / xhr.total * 100 ) + '% loaded' );
        },
        function(error) {
          // called when loading has errors
          console.log('An error happened loading the file');
        }
      );
    } else if (obj.playerSettings.fileType == 'dae') {
      var loader = new THREE.ColladaLoader();
      loader.load(
        obj.playerSettings.file,
        function(collada) {
          //	console.log(collada);
          obj.config.threeJSObj.object = collada.scene; //collada.scene.children[0];
          obj.config.threeJSObj.scene.add(obj.config.threeJSObj.object);

          ScaleObjectToView(obj.config.threeJSObj.object);
        },
        function(xhr) {
          // called when loading is in progresses
          //		console.log( ( xhr.loaded / xhr.total * 100 ) + '% loaded' );
        },
        function(error) {
          // called when loading has errors
          console.log('An error happened loading the file');
        }
      );
    }
  };

  var ScaleObjectToView = function(object) {
    /*
			//	object.geometry.computeBoundingBox();
		
				var objectBoundingBox = new THREE.Box3().setFromObject(object); //new THREE.Box3();//
			//	objectBoundingBox = object.geometry.boundingBox;
				var sizeOfObjectBoundingBox = objectBoundingBox.getSize();
		
				var sceneBoundingBox = new THREE.Box3(new THREE.Vector3( -1, -1, -1 ), new THREE.Vector3( 1, 1, 1 ));
				var sizeOfSceneBoundingBox = sceneBoundingBox.getSize();
		
				var ratio = sizeOfSceneBoundingBox.divide( sizeOfObjectBoundingBox );
				var amount = ratio.x;
				if(ratio.y < amount){
					amount = ratio.y;
				}
				if(ratio.z < amount){
					amount = ratio.z;
				}
		
				// center the mesh before scaling it
				var middle = new THREE.Vector3();
				var worldMiddle = new THREE.Vector3();
		
				middle.x = (objectBoundingBox.max.x + objectBoundingBox.min.x) / 2;
				middle.y = objectBoundingBox.min.y; //(objectBoundingBox.max.y + objectBoundingBox.min.y) / 2;
				middle.z = (objectBoundingBox.max.z + objectBoundingBox.min.z) / 2;
		
				worldMiddle = object.localToWorld( middle );
		
				// there's also mesh.geometry.center() and mesh.geometry.translate ( x : Float, y : Float, z : Float );
		
				var goalMiddle = new THREE.Vector3(0, 0, 0);
				object.position.set(goalMiddle.x - worldMiddle.x, goalMiddle.y - worldMiddle.y, goalMiddle.z - worldMiddle.z);
		
		
		
				object.scale.set(amount, amount, amount);
		*/

    var mroot = object;
    var bbox = new THREE.Box3().setFromObject(mroot);
    var cent = bbox.getCenter(new THREE.Vector3());
    var size = bbox.getSize(new THREE.Vector3());

    // Rescale the object to normalized space
    // since player and camera view is twice as wide as it is tall, multiply x and z by 0.5 so wider objects fit better
    var maxAxis = Math.max(0.5 * size.x, size.y, 0.5 * size.z);
    mroot.scale.multiplyScalar(1.0 / maxAxis);
    bbox.setFromObject(mroot);
    bbox.getCenter(cent);
    bbox.getSize(size);
    //Reposition to 0, halfY, 0
    mroot.position.copy(cent).multiplyScalar(-1);
    mroot.position.y += size.y * 0.5;
  };

  var VRAnimateCamera = function(lat, lon) {
    obj.config.threeJSObj.animatingCamera = true;
    obj.config.threeJSObj.startLat = obj.config.threeJSObj.lat;
    obj.config.threeJSObj.startLon = obj.config.threeJSObj.lon;
    obj.config.threeJSObj.targetLat = lat;
    obj.config.threeJSObj.targetLon = lon;
    obj.config.threeJSObj.startTime = new Date().getTime();

    var distanceForMaxAnimLength = 90;
    var xdistance = obj.config.threeJSObj.targetLat - obj.config.threeJSObj.startLat;
    var yDistance = obj.config.threeJSObj.targetLon - obj.config.threeJSObj.startLon;
    var distanceToTarget = Math.sqrt(Math.pow(xdistance, 2) + Math.pow(yDistance, 2));

    var animPercent = distanceToTarget / distanceForMaxAnimLength;
    if (animPercent < 0) animPercent = 0;
    if (animPercent > 1) animPercent = 1;

    obj.config.threeJSObj.endTime = obj.config.threeJSObj.startTime + obj.config.vrCameraAnimationLength * animPercent;
  };

  var VRAnimate = function() {
    if (obj.config.threeJSObj.animatingCamera) {
      if (obj.config.threeJSObj.endTime - obj.config.threeJSObj.startTime > 0) {
        var curTime = new Date().getTime();
        var percentComplete =
          (curTime - obj.config.threeJSObj.startTime) /
          (obj.config.threeJSObj.endTime - obj.config.threeJSObj.startTime);

        percentComplete = EaseOutQuad(percentComplete);

        if (percentComplete >= 1) {
          obj.config.threeJSObj.animatingCamera = false;
          obj.config.threeJSObj.lat = obj.config.curLat = obj.config.threeJSObj.targetLat;
          obj.config.threeJSObj.lon = obj.config.curLon = obj.config.threeJSObj.targetLon;

          ShowCommentsAtCurrentTime();
          /*	if(commentToPop){
							obj.PopupCommentDotWithClass(commentToPop);
							obj.PopupCommentImageWithClass(commentToPop);
							commentToPop = "";
							commentToPopTime = 0;
						}*/
        } else {
          obj.config.threeJSObj.lat =
            obj.config.threeJSObj.startLat +
            (obj.config.threeJSObj.targetLat - obj.config.threeJSObj.startLat) * percentComplete;
          obj.config.threeJSObj.lon =
            obj.config.threeJSObj.startLon +
            (obj.config.threeJSObj.targetLon - obj.config.threeJSObj.startLon) * percentComplete;
        }
      } else {
        obj.config.threeJSObj.animatingCamera = false;
        obj.config.threeJSObj.lat = obj.config.curLat = obj.config.threeJSObj.targetLat;
        obj.config.threeJSObj.lon = obj.config.curLon = obj.config.threeJSObj.targetLon;
        ShowCommentsAtCurrentTime();
      }
    }

    /* clear the old requested animation frame, then set our animate function to fire next time a frame is ready */
    if (obj.config.threeJSObj.requestAnimationId) {
      window.cancelAnimationFrame(obj.config.threeJSObj.requestAnimationId);
    }
    obj.config.threeJSObj.requestAnimationId = requestAnimationFrame(VRAnimate);
    VRRender();
  };

  // Converts from degrees to radians.
  Math.radians = function(degrees) {
    return (degrees * Math.PI) / 180;
  };

  // Converts from radians to degrees.
  Math.degrees = function(radians) {
    return (radians * 180) / Math.PI;
  };

  var VRRender = function() {
    var x, y, z;
    var origin = new THREE.Vector3(0, 0, 0);
    var radius = obj.config.threeJSObj.cameraStartingDistance;
    var rotation = new THREE.Vector3(obj.config.threeJSObj.lat, -1 * obj.config.threeJSObj.lon, 0);

    x = origin.x + radius * Math.cos(Math.radians(rotation.y)) * Math.cos(Math.radians(rotation.x));
    y = origin.y + radius * Math.sin(Math.radians(rotation.x));
    z = origin.z + radius * Math.sin(Math.radians(rotation.y)) * Math.cos(Math.radians(rotation.x));

    obj.config.threeJSObj.camera.position.set(x, y, z);

    /*
				obj.config.threeJSObj.camera.position.set(0, 0, obj.config.threeJSObj.cameraStartingDistance);
				var axis = new THREE.Vector3(0,1,0);
				var theta = obj.config.threeJSObj.lon / 360 * 2 * Math.PI;
				obj.config.threeJSObj.camera.position.applyAxisAngle(axis, theta);
		//		obj.config.threeJSObj.camera.rotateOnWorldAxis(axis, theta);
		
		
				axis = new THREE.Vector3(0,0,1);
				theta = obj.config.threeJSObj.lat / 360 * 2 * Math.PI;
				obj.config.threeJSObj.camera.position.applyAxisAngle(axis, theta);
		//		obj.config.threeJSObj.camera.rotateOnWorldAxis(axis, theta);
			//	console.log(obj.config.threeJSObj.camera.position.x, obj.config.threeJSObj.camera.position.y, obj.config.threeJSObj.camera.position.z);
		*/
    obj.config.threeJSObj.camera.lookAt(obj.config.threeJSObj.scene.position);
    obj.config.threeJSObj.camera.position.y += 0.5;

    //	obj.config.threeJSObj.videoCanvasContext.drawImage(videoPlayer, -obj.config.threeJSObj.videocanvas.width, 0, obj.config.threeJSObj.videocanvas.width, obj.config.threeJSObj.videocanvas.height);
    //	if (obj.config.threeJSObj.texture){
    //		obj.config.threeJSObj.texture.needsUpdate = true;
    //	}

    obj.config.threeJSObj.renderer.render(obj.config.threeJSObj.scene, obj.config.threeJSObj.camera);
  };

  var SetVRView = function(newMode, shouldAnimate) {
    $('.waveplayer_container .vr_playbackmode').removeClass('flat spherical left right disabled');
    $('.waveplayer_container .vr_view_list').html('');

    obj.config.curVRView = newMode;

    $('.waveplayer_container').removeClass('vr_flat');

    $('.waveplayer .vr_render_canvas').show();

    //		obj.playerSettings.ratio = obj.config.vrVideoWidth / obj.config.vrVideoHeight;
    //		obj.playerSettings.width = obj.config.vrVideoWidth;
    //		obj.playerSettings.height = obj.config.vrVideoHeight;

    if (shouldAnimate) {
      VRAnimate();
    }

    if (!obj.config.enableVR) {
      if (obj.config.isiOS) {
        $('.waveplayer_container .vr_view')
          .off('click')
          .on('click', function(e) {
            obj.ToggleFullscreen(false);
            alert(
              'Unfortunately, iOS does not fully support browser-based 360 video. Please view on desktop or Android for the full experience.'
            );
          });
      } else if (obj.config.isIEMobile) {
        $('.waveplayer_container .vr_view')
          .off('click')
          .on('click', function(e) {
            obj.ToggleFullscreen(false);
            alert(
              'Unfortunately, Windows Phone does not fully support browser-based 360 video. Please view on desktop or Android for the full experience.'
            );
          });
      } else if (obj.config.isIE) {
        $('.waveplayer_container .vr_view')
          .off('click')
          .on('click', function(e) {
            obj.ToggleFullscreen(false);
            alert(
              'Unfortunately, Internet Explorer does not fully support browser-based 360 video. Please view in another browser (such as Chrome) for the full experience.'
            );
          });
      } else {
        $('.waveplayer_container .vr_view')
          .off('click')
          .on('click', function(e) {
            obj.ToggleFullscreen(false);
            alert(
              'Unfortunately, your browser does not fully support 360 video. Please view in another browser (such as Chrome) for the full experience.'
            );
          });
      }
    }

    obj.HandleResize();
  };

  this.SetPlaybackQuality = function(newQuality, autostart) {
    originalTime = 0;
    var shouldLoop = false;

    obj.Destroy();

    if (obj.config.isTouch) {
      $('.waveplayer_container').addClass('is_touch');
      $('.waveplayer .playback_volume')
        .addClass('disabled')
        .hide();
    } else {
      $('.waveplayer_container').removeClass('is_touch');
      $('.waveplayer .playback_volume')
        .removeClass('disabled')
        .show();
    }

    $('.waveplayer_container').addClass('initial_controls');
    setTimeout(function() {
      $('.waveplayer_container').removeClass('initial_controls');
    }, 2000);

    var isSafari =
      navigator.vendor &&
      navigator.vendor.indexOf('Apple') > -1 &&
      navigator.userAgent &&
      !navigator.userAgent.match('CriOS');
    var playerDiv;

    if (!obj.CanPlayFile(obj.playerSettings.fileType)) {
      PlaybackError();
      return false;
    }

    $('.waveplayer .waveplayer_container').removeClass('audio');

    if (shouldLoop) {
    }

    $('.waveplayer_container .control_button.vr_view')
      .addClass('disabled')
      .hide();
    //  $(".waveplayer_container .control_button.playback_title_safe, .waveplayer .title_safe").addClass("disabled").hide();
    $('.waveplayer_container .playback_title_safe').addClass('active'); // because we're showing grid

    if (!obj.config.enableVR) {
      //	SetVRView(obj.config.VR_VIEW_FLAT, false);
      alert('3D preview is not supported by your browser.');
    } else {
      obj.playerSettings.isVR = true;
      VRSetup();

      SetVRView(obj.config.VR_VIEW_SPHERICAL, true);
    }

    $('.waveplayer_container .comment_canvas')
      .attr('height', obj.config.videoCanvasHeight)
      .show();
    //    $(".waveplayer .vr_render_canvas").hide();
    //    $(".waveplayer .waveplayer_container").removeClass("is_vr");
    //    $(".waveplayer_container .control_button.vr_view").addClass("disabled").hide();
    //    $(".waveplayer_container .control_button.playback_title_safe, .waveplayer .title_safe").removeClass("disabled");
    //    $(".waveplayer_container .control_button.playback_title_safe").show();

    $('.waveplayer_container .playback_quality')
      .addClass('disabled')
      .hide();

    $('.waveplayer_container .playback_quality').unbind('click');

    var wavePlayerDiv = $('.waveplayer .waveplayer_container')[0];
    wavePlayerDiv.addEventListener('webkitbeginfullscreen', WebkitBeginFullscreenHandler);
    wavePlayerDiv.addEventListener('webkitendfullscreen', WebkitEndFullscreenHandler);

    document.addEventListener('fullscreenchange', FullscreenChange);
    document.addEventListener('webkitfullscreenchange', FullscreenChange);
    document.addEventListener('mozfullscreenchange', FullscreenChange);
    document.addEventListener('MSFullscreenChange', FullscreenChange);

    document.addEventListener('fullscreenerror', FullscreenError);
    document.addEventListener('webkitfullscreenerror', FullscreenError);
    document.addEventListener('mozfullscreenerror', FullscreenError);
    document.addEventListener('MSFullscreenError', FullscreenError);

    obj.HandleResize();
    $(window).on('resize', obj.HandleResize);
    $(window).on('orientationchange', OrientationChangeHandler);

    SetupClicks();

    $('.waveplayer .title_safe')
      .off('mousedown touchstart')
      .on('mousedown touchstart', function(e) {
        /* needed for browsers that don't support pointer-events: none CSS */
        $('.waveplayer .interaction_target').trigger(e);
      });

    $('.waveplayer .interaction_target')
      .off('mousedown touchstart')
      .on('mousedown touchstart', function(e) {
        e.preventDefault();
        e.stopPropagation();

        if (
          obj.playerSettings.isVR &&
          obj.config.curVRView != obj.config.VR_VIEW_FLAT &&
          obj.config.curVRView != obj.config.VR_MODE_NONE &&
          !$('.waveplayer_container .comment_point').hasClass('active') &&
          !$('.waveplayer_container .comment_paint').hasClass('active')
        ) {
          $('.waveplayer_container').addClass('grabbing_vr');
          isGrabbingVR = true;

          obj.CancelNewComment();
          obj.HideComments();
          //	ClearCommentCanvas();

          var target = $('.waveplayer .interaction_target'); /*  .media_comment_holder  */ /* $(this); */
          var mouse = GetMousePosition(e);

          obj.config.threeJSObj.mouseDown = true;
          obj.config.threeJSObj.dragStart.x = mouse.x;
          obj.config.threeJSObj.dragStart.y = mouse.y;

          $(document)
            .on('mousemove touchmove', function(e) {
              e.preventDefault();
              var mouse = GetMousePosition(e);
              /*obj.config.threeJSObj.onPointerDownPointerX = mouse.x;
					obj.config.threeJSObj.onPointerDownPointerY = -mouse.y;*/

              /* threeJSObj.relativeX = event.pageX - glCanvas.find('canvas').offset().left; */
              /*obj.config.threeJSObj.relativeX = e.pageX - obj.config.threeJSObj.glCanvas.offset().left;*/

              /*obj.config.threeJSObj.onPointerDownLon = obj.config.threeJSObj.lon;
					obj.config.threeJSObj.onPointerDownLat = obj.config.threeJSObj.lat;*/

              var x, y, xMultiplier, yMultiplier;

              if (obj.config.threeJSObj.glCanvas.width() > 0 && obj.config.threeJSObj.glCanvas.height() > 0) {
                /* .find('canvas') */
                xMultiplier = 180 / obj.config.threeJSObj.glCanvas.width(); /* .find('canvas') */
                yMultiplier = 180 / obj.config.threeJSObj.glCanvas.height(); /* .find('canvas') */
              } else {
                xMultiplier = 180 / 1280;
                yMultiplier = 180 / 720;
              }

              var draggingMode = true;
              if (draggingMode) {
                if (obj.config.threeJSObj.mouseDown) {
                  x = mouse.x - obj.config.threeJSObj.dragStart.x;
                  y = mouse.y - obj.config.threeJSObj.dragStart.y;

                  obj.config.threeJSObj.dragStart.x = mouse.x;
                  obj.config.threeJSObj.dragStart.y = mouse.y;

                  obj.config.threeJSObj.lon = obj.config.threeJSObj.lon - x * xMultiplier; // % 360;
                  obj.config.threeJSObj.lat = obj.config.threeJSObj.lat + y * yMultiplier; // % 360;

                  if (obj.config.threeJSObj.lat < -90) obj.config.threeJSObj.lat = -90;
                  if (obj.config.threeJSObj.lat > 90) obj.config.threeJSObj.lat = 90;

                  obj.config.curLon = obj.config.threeJSObj.lon;
                  obj.config.curLat = obj.config.threeJSObj.lat;
                }
              } else {
                x = mouse.x - obj.config.threeJSObj.glCanvas.offset().left; /* .find('canvas') */
                y = mouse.y - obj.config.threeJSObj.glCanvas.offset().top; /* .find('canvas') */
                obj.config.threeJSObj.lon =
                  (x / obj.config.threeJSObj.glCanvas.width()) * 430 - 225; /* .find('canvas') */
                obj.config.threeJSObj.lat =
                  (y / obj.config.threeJSObj.glCanvas.height()) * -180 + 90; /* .find('canvas') */
              }
            })
            .one('mouseup touchend', function(e) {
              e.preventDefault();
              $('.waveplayer_container').removeClass('grabbing_vr');
              isGrabbingVR = false;
              $(document).off('mousemove touchmove');
              obj.config.threeJSObj.mouseDown = false;
              ShowCommentsAtCurrentTime();
            });
        } else if ($('.waveplayer_container').hasClass('enable_comments')) {
          $('.waveplayer_container').addClass('making_comment');
          //	obj.Pause();
          var target = $('.waveplayer .interaction_target'); /*  .media_comment_holder  */ /* $(this); */
          var mouse = GetMousePosition(e);

          if (
            $('.waveplayer_container .comment_point').hasClass('active') &&
            target.width() > 0 &&
            target.height() > 0
          ) {
            $('.waveplayer_container .comment_clear_button').removeClass('disabled');

            var xPos, yPos, uv;

            //		if(obj.playerSettings.isVR && obj.config.curVRView != obj.config.VR_VIEW_FLAT && obj.config.curVRView != obj.config.VR_MODE_NONE ){
            //			uv = GetUVFromMouse(mouse.x, mouse.y);
            //			xPos = uv.u;
            //			yPos = uv.v;
            //		} else {
            xPos = (mouse.x - target.offset().left) / target.width();
            yPos = (mouse.y - target.offset().top) / target.height();
            //		}

            if (xPos < 0) xPos = 0;
            if (xPos > 1) xPos = 1;
            if (yPos < 0) yPos = 0;
            if (yPos > 1) yPos = 1;

            commentInEdit['xPos'] = xPos;
            commentInEdit['yPos'] = yPos;
            commentInEdit['lat'] = obj.config.curLat;
            commentInEdit['lon'] = obj.config.curLon;
            commentInEdit['vrView'] = obj.config.curVRView;
            //		commentInEdit['time']	 		= obj.GetCurrentTime();
            commentInEdit['color'] = obj.config.commentColor;
            commentInEdit['isDot'] = true;
            if (commentInEdit['dot']) {
              commentInEdit['dot'].remove();
            }
            //		if(!obj.playerSettings.isVR){
            commentInEdit['dot'] = $("<div class='comment_dot' />").appendTo(target);
            //		}
            commentInEdit['isDrawing'] = false;
            commentInEdit['drawingBase64'] = '';
            commentInEdit['drawingPath'] = '';
            commentInEdit['drawingImg'] = null;
            commentInEdit['progressDot'] = null;
            commentInEdit['isEditing'] = true;

            //		if(!obj.playerSettings.isVR){
            var thisDot = commentInEdit['dot'];
            thisDot.css({
              left: xPos * 100 + '%',
              top: yPos * 100 + '%',
              'background-color': obj.config.commentColorOptions[obj.config.commentColor]
            });
            obj.ShowCommentDot(thisDot, true);
            //		} else {
            //			ClearCommentCanvas();
            //			ShowCommentsAtCurrentTime();
            //			DrawCommentDot(xPos, yPos, obj.config.commentColorOptions[obj.config.commentColor], false, true);
            //		}

            $('.waveplayer_container').removeClass('making_comment');

            $(document).one('mouseup touchend', function() {
              obj.trigger('shapeDrawn.waveplayer', [obj.GetCommentInEdit(), e]);
            });

            if (
              !obj.config.isTouch &&
              !obj.config.isFullscreen &&
              typeof obj.playerSettings.commentsClickFallback == 'function'
            ) {
              obj.playerSettings.commentsClickFallback();
            }
          } else if ($('.waveplayer_container .comment_paint').hasClass('active')) {
            $('.waveplayer_container .comment_clear_button').removeClass('disabled');

            $('.waveplayer_container').addClass('drawing_comment');
            MouseDraw(e);

            $(document)
              .on('mousemove touchmove', function(e) {
                e.preventDefault();
                MouseDraw(e);
              })
              .one('mouseup touchend', function(e) {
                e.preventDefault();
                MouseDraw(e);
                isDrawingOnCanvas = false;
                $('.waveplayer_container').removeClass('drawing_comment');
                $('.waveplayer_container').removeClass('making_comment');
                $(document).off('mousemove touchmove');

                var dataURL = $('.waveplayer .comment_canvas.in_progress')[0].toDataURL('image/png');

                commentInEdit['xPos'] = 0;
                commentInEdit['yPos'] = 0;
                commentInEdit['lat'] = obj.config.curLat;
                commentInEdit['lon'] = obj.config.curLon;
                commentInEdit['vrView'] = obj.config.curVRView;
                //			commentInEdit['time'] 			= obj.GetCurrentTime();
                commentInEdit['color'] = obj.config.commentColor;
                commentInEdit['isDot'] = false;
                if (commentInEdit['dot']) {
                  commentInEdit['dot'].remove();
                }
                commentInEdit['dot'] = null;
                commentInEdit['isDrawing'] = true;
                commentInEdit['drawingBase64'] = dataURL;
                commentInEdit['drawingPath'] = '';
                commentInEdit['drawingImg'] = null;
                commentInEdit['progressDot'] = null;
                commentInEdit['isEditing'] = true;

                if (
                  !obj.config.isTouch &&
                  !obj.config.isFullscreen &&
                  typeof obj.playerSettings.commentsClickFallback == 'function'
                ) {
                  obj.playerSettings.commentsClickFallback();
                }

                obj.trigger('shapeDrawn.waveplayer', [commentInEdit, e]);
              });
          }
        }
      });
  }; /*
      obj.GoToTime(originalTime);
    }

    obj.playerSettings.duration = videoPlayer.duration;

    if(!obj.playerSettings.isVR){
      obj.playerSettings.width = videoPlayer.videoWidth;
      obj.playerSettings.height = videoPlayer.videoHeight;

      obj.playerSettings.ratio = 16/9;
      if(obj.playerSettings.width > 0 && obj.playerSettings.height > 0){
        obj.playerSettings.ratio = obj.playerSettings.width / obj.playerSettings.height;
      }
    }


    $(".waveplayer .waveplayer_container .media video").attr("width", "100%");
    $(".waveplayer .waveplayer_container .media video").attr("height", "100%");

    if(obj.config.isFullscreen || obj.config.isAudio){
      $(".waveplayer .waveplayer_container").height("");
    } else {
      $(".waveplayer .waveplayer_container").height($(".waveplayer .waveplayer_container").width() / obj.playerSettings.ratio);
    }

    if(videoPlayer && videoPlayer.duration > 0 && $(".waveplayer .progress_container").width() > 0){
      var progressPercent, progressDot;

      for(var i = 0; i < obj.config.comments.length; i++){
        progressDot = obj.config.comments[i]['progressDot'];
        progressPercent = obj.config.comments[i]['time'] / videoPlayer.duration;
        progressDot.css({"display": "block", "left": (progressPercent * 100) + "%"});
      }

    }

    UpdateTimecodeDisplay(0, obj.playerSettings.duration);
    obj.HandleResize();
    $(window).on("resize", obj.HandleResize);
    $(window).on("orientationchange", OrientationChangeHandler);

    /* $(".waveplayer").on("widthChange", obj.HandleResize());  */ /*
	
		ProgressHandler = function() {
			if(!isDraggingTimePosition){
				var range = 0;
				var bf = videoPlayer.buffered;
				var time = videoPlayer.currentTime;
				var duration = videoPlayer.duration;
				var loadStartPercentage = 0, loadEndPercentage = 0, loadPercentage = 0;
	
				for(var i = 0; i < bf.length; i++){
					if(bf.start(i) <= time && time <= bf.end(i)){
						range = i;
					}
				}
	
				if(duration > 0 && range < bf.length){
					loadStartPercentage = bf.start(range) / duration;
					loadEndPercentage = bf.end(range) / duration;
				}
	
				loadPercentage = loadEndPercentage - loadStartPercentage;
      $(".waveplayer .progress_container .progress_buffered").css("left", loadStartPercentage*100 + "%").css("width", loadPercentage*100 + "%");
	
			}
	
		};
	
		TimeUpdateHandler = function(){
	
    if($(".waveplayer_container .playback_seeking").is(":visible")){
				SeekingAnimation(false);
			}
	
			var time = videoPlayer.currentTime;
			var duration = videoPlayer.duration;
	
			if(obj.playerSettings.duration == 1 && duration > 1){
				obj.playerSettings.duration = duration;
			}
	
			UpdateTimecodeDisplay(time, duration);
			if(commentToPop && time == commentToPopTime){
				ShowCommentsAtCurrentTime();
				obj.PopupCommentDotWithClass(commentToPop);
				obj.PopupCommentImageWithClass(commentToPop);
				commentToPop = "";
				commentToPopTime = 0;
			}
	
			var playedPercentage = 0;
			if(duration > 0){
				playedPercentage = time / duration;
			}
	
			if(obj.config.isAudio){
      $(".waveplayer_container .audio_line").css("left", playedPercentage*100 + "%");
			}
	
    if(!obj.isPaused() && $(".waveplayer .progress_playback").hasClass("no_animate")){
      $(".waveplayer .progress_playback, .waveplayer_container .audio_line").removeClass("no_animate");
			}
    $(".waveplayer .progress_playback").css("width", playedPercentage*100 + "%");
	
		};
	
		PlayHandler = function() {
    $(".waveplayer_container .playback_play_pause").removeClass("paused");
			obj.HideComments();
			obj.CancelNewComment();
		};
	
		PauseHandler = function() {
    $(".waveplayer_container .playback_play_pause").addClass("paused");
			ShowCommentsAtCurrentTime();
		};
	
		SeekingHandler = function() {
			SeekingAnimation(true);
		};
	
		SeekedHandler = function() {
			SeekingAnimation(false);
			ShowCommentsAtCurrentTime();
		};
	
		StalledHandler = function() {
			if(!obj.isPaused()){
      if(curQuality == "HD" && canDoSD){
        obj.SetPlaybackQuality("SD", !obj.isPaused());
				}
			}
		};
*/ /*
  };
*/

  /* event handlers */
  /*
  LoadedMetadataHandler = function(){
    if(!obj.config.isiOS || originalTime > 0.1){ /* hack to fix how on old iOS, setting currentTime to 0 broke the property  */
  var WebkitBeginFullscreenHandler = function() {
    obj.ToggleFullscreen(true);
  };

  var WebkitEndFullscreenHandler = function(e) {
    /*if(typeof CustomEvent == 'function' && videoPlayer && videoPlayer.dispatchEvent){
      var event = new CustomEvent("timeupdate", { "detail": "timeupdate" });

			videoPlayer.dispatchEvent(event);
		}*/
    obj.ToggleFullscreen(false);
  };

  var OrientationChangeHandler = function() {
    obj.HandleResize();
    setTimeout(function() {
      obj.HandleResize();
    }, 1000);
  };

  var KeydownHandler = function(e) {
    if (videoPlayer) {
      var foundFocus = false;

      $(document)
        .find('textarea,:text,input')
        .each(function() {
          if ($(this).is(':focus')) {
            foundFocus = true;
          }
        });

      if (!foundFocus) {
        var seekAmount = 1 / 30;
        if (obj.playerSettings.framerate > 0) {
          seekAmount = 1 / obj.playerSettings.framerate;
        }

        if (e.which == 32 || e.which == 75 || e.which == 107) {
          /* space bar or K  or k */
          e.preventDefault();
          obj.TogglePause();
          if (obj.isPaused()) {
            obj.ShowMessage("<div class='pause_black'></div>");
          } else {
            obj.ShowMessage("<div class='play_black'></div>");
          }
        } else if (e.which == 76 || e.which == 108) {
          /* L or l */
          e.preventDefault();
          if (!isPlayingBackward && obj.isPaused()) {
            obj.Play();
            obj.ShowMessage("<div class='play_black'></div>");
          } else {
            if (obj.playerSettings.playbackSpeed != -1) {
              obj.SpeedUp();
              obj.ShowMessage(obj.playerSettings.playbackSpeed + 'x');
            } else {
              obj.SpeedUp();
            }
          }
        } else if (e.which == 74 || e.which == 106) {
          /* J or j */
          e.preventDefault();
          if (obj.isPaused()) {
            obj.PlayBackwards();
            obj.ShowMessage(obj.playerSettings.playbackSpeed + 'x');
          } else {
            obj.SlowDown();
            obj.ShowMessage(obj.playerSettings.playbackSpeed + 'x');
          }
        } else if (e.which == 37) {
          /* left arrow */
          e.preventDefault();
          obj.Pause();
          /* $(".fp-waiting").css("visibility", "hidden"); */
          obj.GoToTime(videoPlayer.currentTime - seekAmount);
          /*obj.GoToTime(obj.GetCurrentTime() - seekAmount); /* rounds down to the closest frame first */
        } else if (e.which == 39) {
          /* right arrow */
          e.preventDefault();
          obj.Pause();
          /* $(".fp-waiting").css("visibility", "hidden"); */
          obj.GoToTime(videoPlayer.currentTime + seekAmount);
          /*obj.GoToTime(obj.GetCurrentTime() + seekAmount); /* rounds down to the closest frame first */
        } else if (e.which == 27) {
          /* escape */
          /*e.preventDefault();*/

          if (obj.config.isFullscreen) {
            setTimeout(function() {
              obj.HandleResize();
            }, 1000);
          }
        } else if (e.which == 80) {
          /* p */
          /*e.preventDefault();*/

          if ($('.waveplayer_container').hasClass('enable_comments')) {
            $('.waveplayer_container .comment_point').click();
          }
        } else if (e.which == 66) {
          /* b */
          /*e.preventDefault();*/

          if ($('.waveplayer_container').hasClass('enable_comments')) {
            $('.waveplayer_container .comment_paint').click();
          }
        } else if (e.which == 72) {
          /* h */
          /*e.preventDefault();*/

          if ($('.waveplayer_container').hasClass('enable_comments')) {
            $('.waveplayer_container .hand_icon').click();
          }
        } else if (e.which == 13) {
          /* Enter */
          e.preventDefault();
          obj.Pause();
          if (
            !obj.config.isTouch &&
            !obj.config.isFullscreen &&
            typeof obj.playerSettings.commentsClickFallback == 'function'
          ) {
            obj.playerSettings.commentsClickFallback();
          }
        }

        /*		} else if(e.which == 38){ /* up arrow */
        /*			e.preventDefault();
				/*			api.volume(Math.min(1, api.volumeLevel + .1));
				/*
				/*		} else if(e.which == 40){ /* down arrow */
        /*			e.preventDefault();
				/*			api.volume(Math.max(0, api.volumeLevel - .1));
				/*
				/*		}
				*/
      }
    }
  };

  /* end handlers */

  this.SetCommentFallbackFunction = function(newFunc) {
    if (typeof newFunc == 'function') {
      obj.playerSettings.commentsClickFallback = newFunc;
    }
  };

  this.DeleteComments = function(shouldCancelNewComment) {
    for (var i = 0; i < obj.config.comments.length; i++) {
      if (obj.config.comments[i]['dot']) {
        obj.config.comments[i]['dot'].remove();
      }
      if (obj.config.comments[i]['progressDot']) {
        obj.config.comments[i]['progressDot'].remove();
      }
      if (obj.config.comments[i]['drawingImg']) {
        obj.config.comments[i]['drawingImg'].remove();
      }
    }
    obj.config.comments.length = 0;
    if (shouldCancelNewComment === true) {
      obj.CancelNewComment();
    }
    ClearCommentCanvas(true);
  };

  this.HideCommentDot = function(theDot) {
    theDot.removeClass('visible normal large').hide();
  };
  this.PopupCommentDotWithClass = function(theClass) {
    var theDot = $('.waveplayer_container .media').find($('.comment_dot.' + theClass));
    if (theDot) {
      obj.ShowCommentDot(theDot, true);
    }
  };
  this.PopupCommentImageWithClass = function(theClass) {
    var theImage = $('.waveplayer_container .media').find($('.comment_drawing.' + theClass));
    if (theImage) {
      obj.ShowCommentImage(theImage, true);
    }
  };

  this.ShowCommentDot = function(theDot, shouldAnimate) {
    obj.HideCommentDot(theDot);

    theDot
      .removeClass('visible normal large')
      .show()
      .addClass('visible');

    if (shouldAnimate) {
      theDot.delay(50).queue(function() {
        $(this)
          .addClass('large')
          .dequeue();
        $(this)
          .delay(150)
          .queue(function() {
            $(this)
              .addClass('normal')
              .removeClass('large')
              .dequeue();
          });
      });
    } else {
      theDot.addClass('normal');
    }
  };

  this.ShowCommentImage = function(theImage, shouldAnimate) {
    theImage
      .addClass('visible')
      .removeClass('bright')
      .show();

    if (shouldAnimate) {
      theImage.delay(50).queue(function() {
        $(this)
          .addClass('bright')
          .dequeue();
        $(this)
          .delay(150)
          .queue(function() {
            $(this)
              .removeClass('bright')
              .dequeue();
          });
      });
    } else {
      theImage.removeClass('bright');
    }
  };

  this.HideComments = function() {
    for (var i = 0; i < obj.config.comments.length; i++) {
      if (obj.config.comments[i]['dot']) {
        obj.HideCommentDot(obj.config.comments[i]['dot']);
      }
      if (obj.config.comments[i]['drawingImg']) {
        obj.config.comments[i]['drawingImg'].removeClass('visible').hide();
      }
      $('#comment_' + obj.config.comments[i]['uniqueID']).css('border-left', 'none');
    }
    ClearCommentCanvas();
  };
  /*
		DrawCommentDot = function(xPos, yPos, color, ignoreBorders, in_progress){
			var canvasObj;
			if(in_progress){
      canvasObj = $(".waveplayer .comment_canvas.in_progress");
			} else {
      canvasObj = $(".waveplayer .comment_canvas.done");
			}
	
    var canvasContext = canvasObj[0].getContext("2d");
    var canvasWidth = canvasObj.attr("width"),
      canvasHeight = canvasObj.attr("height");
	
			if(canvasWidth <= 0 || canvasHeight <= 0) return false;
	
    var centerX = xPos * canvasObj.attr("width"),
      centerY = yPos * canvasObj.attr("height"),
				radius = 5;
	
	
	
			canvasContext.beginPath();
			canvasContext.arc(centerX, centerY, 1.5 * radius, 0, 2 * Math.PI, false);
			canvasContext.lineWidth = radius;
			canvasContext.strokeStyle = 'rgba(255, 255, 255, 1.0)';
			canvasContext.stroke();
	
			canvasContext.beginPath();
			canvasContext.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
			canvasContext.fillStyle = color;
			canvasContext.fill();
	
			if(ignoreBorders !== true){
				if(centerX < 2*radius) DrawCommentDot(xPos + 1.0, yPos, color, true, in_progress);
				if(centerX > canvasWidth - 2*radius) DrawCommentDot(xPos - 1.0, yPos, color, true, in_progress);
			}
		};
	*/
  var ClearCommentCanvas = function(keepInProgress) {
    var canvasObj1 = $('.waveplayer .comment_canvas.done');
    var canvasObj2 = $('.waveplayer .comment_canvas.in_progress');
    if (canvasObj1[0] && typeof canvasObj1[0].getContext == 'function') {
      var canvasContext1 = canvasObj1[0].getContext('2d');
      canvasContext1.clearRect(0, 0, canvasObj1.attr('width'), canvasObj1.attr('height'));
    }
    if (keepInProgress !== true) {
      if (canvasObj2[0] && typeof canvasObj2[0].getContext == 'function') {
        var canvasContext2 = canvasObj2[0].getContext('2d');
        canvasContext2.clearRect(0, 0, canvasObj2.attr('width'), canvasObj2.attr('height'));
      }
    }
  };

  var ShowCommentsAtCurrentTime = function() {
    if (obj.config.commentsVisible) {
      var scrollToVal, commentDiv, numWholeFrames;
      var viewThreshold = 0.1;
      for (var i = 0; i < obj.config.comments.length; i++) {
        if (!obj.config.comments[i]['isEditing']) {
          if (
            !obj.config.threeJSObj.animatingCamera &&
            !isDrawingOnCanvas &&
            !isGrabbingVR &&
            Math.abs(obj.config.comments[i]['lat'] - obj.config.curLat) < viewThreshold &&
            Math.abs(obj.config.comments[i]['lon'] - obj.config.curLon) < viewThreshold
          ) {
            if (obj.config.comments[i]['dot']) {
              obj.ShowCommentDot(obj.config.comments[i]['dot'], false);
            } else if (obj.config.comments[i]['drawingImg']) {
              obj.ShowCommentImage(obj.config.comments[i]['drawingImg'], false);
            }

            $('#comment_' + obj.config.comments[i]['uniqueID']).css(
              'border-left',
              '2px solid ' + obj.config.comments[i]['color']
            );
          } else {
            if (obj.config.comments[i]['dot']) {
              obj.HideCommentDot(obj.config.comments[i]['dot']);
            }
            if (obj.config.comments[i]['drawingImg']) {
              obj.config.comments[i]['drawingImg'].removeClass('visible').hide();
            }
            $('#comment_' + obj.config.comments[i]['uniqueID']).css('border-left', 'none');
          }
        }
      }
    } else {
    }
  };

  this.AddComment = function(uniqueID, xPos, yPos, lat, lon, vrView, time, color, isDot, isDrawing, drawingPath) {
    obj.config.comments.push({
      xPos: xPos,
      yPos: yPos,
      lat: lat,
      lon: lon,
      vrView: vrView,
      time: time,
      color: color,
      dot: null,
      isDot: isDot,
      isDrawing: isDrawing,
      drawingBase64: '',
      drawingPath: drawingPath,
      drawingImg: null,
      progressDot: null,
      isEditing: false,
      uniqueID: uniqueID
    });
    var target = $('.waveplayer .media_comment_holder');
    if (isDot && target.width() > 0 && target.height() > 0) {
      var thisDot = (obj.config.comments[obj.config.comments.length - 1]['dot'] = $(
        "<div class='comment_dot " + uniqueID + "' style='display: none;'/>"
      ).appendTo(target));
      thisDot.css({ left: xPos * 100 + '%', top: yPos * 100 + '%', 'background-color': color });
    } else if (isDrawing) {
      var thisImg = (obj.config.comments[obj.config.comments.length - 1]['drawingImg'] = $(
        "<img class='comment_drawing " + uniqueID + "' crossorigin='anonymous' style='display: none;'/>"
      ).appendTo(target));
      thisImg.attr('src', drawingPath);
    }

    ShowCommentsAtCurrentTime();
  };

  this.GetCommentInEdit = function() {
    if (commentInEdit) {
      return {
        xPos: commentInEdit['xPos'],
        yPos: commentInEdit['yPos'],
        lat: obj.config.curLat /* commentInEdit['lat'], */,
        lon: obj.config.curLon /* commentInEdit['lon'], */,
        vrView: obj.config.curVRView,
        time: commentInEdit['time'],
        color: obj.config.commentColorOptions[commentInEdit['color']],
        dot: null,
        isDot: commentInEdit['isDot'],
        isDrawing: commentInEdit['isDrawing'],
        drawingBase64: commentInEdit['drawingBase64'],
        drawingPath: '',
        drawingImg: null,
        progressDot: null,
        isEditing: false,
        uniqueID: ''
      };
    } else {
      return false;
    }
  };

  this.CommitNewComment = function() {
    if (commentInEdit) {
      obj.config.comments.push(commentInEdit);
      commentInEdit = null;
    }
  };

  this.CancelNewComment = function() {
    /*$(".waveplayer_container").removeClass("cursor_comment_paint").removeClass("cursor_comment_point");
    $(".waveplayer_container .comment_paint").removeClass("active");
    $(".waveplayer_container .comment_point").removeClass("active");*/

    /*var canvasObj = $(".waveplayer .comment_canvas");
    var canvasContext = canvasObj[0].getContext("2d");
    canvasContext.clearRect(0, 0, canvasObj.attr("width"), canvasObj.attr("height"));*/

    if (commentInEdit && commentInEdit['isDot']) {
      if (commentInEdit['dot']) {
        commentInEdit['dot'].remove();
      }
      commentInEdit['dot'] = null;
      commentInEdit['isDot'] = false;
      ClearCommentCanvas();
    } else if (commentInEdit && commentInEdit['isDrawing']) {
      commentInEdit['drawingBase64'] = '';
      commentInEdit['isDrawing'] = false;
      ClearCommentCanvas();
    }

    ShowCommentsAtCurrentTime();

    $('.waveplayer_container .comment_clear_button').addClass('disabled');

    /*if(commentInEdit && commentInEdit['drawingBase64']){
			commentInEdit['drawingBase64'] = "";
		}

		if(commentInEdit && commentInEdit['dot']){
			commentInEdit['dot'].remove();
			commentInEdit['dot'] = null;
		}

		commentInEdit['isDrawing'] = false;
		commentInEdit['isDot'] = false;

		ClearCommentCanvas();
		ShowCommentsAtCurrentTime();
		*/
  };

  /*
		this.SetFramerate = function(newFPS, newStartTimecode){
			obj.playerSettings.framerate = parseFloat(newFPS) || 29.97;
			obj.playerSettings.startTime = parseFloat(newStartTimecode) || 0;
		};
	
	
		FormatTime = function(time){
	
			time = parseFloat(time);
			var framerate = parseFloat(obj.playerSettings.framerate) || 0;
	
			var hours = Math.floor(time / 3600);
			var mins = Math.floor((time / 60) % 60);
			var secs = (time % 60);
			var frames = secs - Math.floor(secs);
			secs = Math.floor(secs);
			var frames_separator = '.';
	
			if(framerate > 0 && typeof framerate !== 'undefined'){
				frames = Math.floor(frames * framerate);
				frames_separator = ':';
				frames_text = frames < 10 ? '0' + frames : frames;
			}else{
				frames = frames.toFixed(3);
				frames_text = String(frames).substr(2);
			}
	
			var minutes = mins < 10 ? '0' + mins : mins;
			var seconds = secs < 10 ? '0' + secs : secs;
	
			return hours + ':' + minutes + ':' + seconds + frames_separator + frames_text;
		};
	
	
	
		ConvertSecondsToSMPTE = function(time) {
	
			var dropframes = 0;
			time = parseFloat(time) || 0;
			var framerate = parseFloat(obj.playerSettings.framerate);
	
			if (framerate > 29 && framerate < 30){
				dropframes = 2;
			} else if (framerate > 59 && framerate < 60){
				dropframes = 4;
			} else {
				dropframes = 0;
			}
	
			var totalFrames = framerate * time;
			var framesLeft = framerate * time;
			var roundedFramerate = Math.round(framerate);
	
			if(framerate <= 0 || roundedFramerate <= 0){
				return FormatTime(time);
			}
	
			var totalMinutes = Math.floor(totalFrames / (60 * roundedFramerate));
			var totalDropframes = dropframes * (totalMinutes - Math.floor(totalMinutes / 10));
	
	
	
			var newDropframes = totalDropframes;
			var oldDropframes = 0;
			var dropDiff = 0;
			var foundAll = false;
	
			while(!foundAll){
	
				dropDiff = dropframes * (Math.floor((totalFrames + newDropframes) / (60 * roundedFramerate)) - Math.floor(Math.floor((totalFrames + newDropframes) / (60 * roundedFramerate)) / 10)) - dropframes * (Math.floor((totalFrames + oldDropframes) / (60 * roundedFramerate)) - Math.floor(Math.floor((totalFrames + oldDropframes) / (60 * roundedFramerate)) / 10));
	
				if(dropDiff > 0){
					oldDropframes = newDropframes;
					newDropframes += dropDiff;
				} else {
					foundAll = true;
				}
	
			}
	
			totalDropframes = newDropframes;
	
	
			totalFrames += totalDropframes;
			framesLeft += totalDropframes;
	
			var hours = Math.floor(totalFrames / (60 * 60 * roundedFramerate));
			framesLeft -= hours * (60 * 60 * roundedFramerate);
	
			var minutes = Math.floor(framesLeft / (60 * roundedFramerate));
			framesLeft -= minutes * (60 * roundedFramerate);
	
			var seconds = Math.floor(framesLeft / roundedFramerate);
			framesLeft -= seconds * roundedFramerate;
	
			var frames = Math.floor(framesLeft);
	
    var sep = ":";
			if(dropframes > 0){
      sep = ";";
			}
	
			var hourstext = String(hours) + sep;
			var minutestext = String(minutes) + sep;
			var secondstext = String(seconds) + sep;
			var framestext = String(frames);
	
			if(hours < 10){
      hourstext = "0" + hourstext;
			}
			if(hours == 0){
				hourstext = "";
			}
			if(minutes < 10){
      minutestext = "0" + minutestext;
			}
			if(seconds <10){
      secondstext = "0" + secondstext;
			}
			if(frames < 10){
      framestext = "0" + framestext;
			}
	
			return hourstext + minutestext + secondstext + framestext;
		};
	*/

  var GetIEVersion = function() {
    var iev = -1;
    var ieold = /MSIE (\d+\.\d+);/.test(navigator.userAgent);
    var trident = !!navigator.userAgent.match(/Trident\/7.0/);
    var rv = navigator.userAgent.indexOf('rv:11.0');

    if (ieold) iev = new Number(RegExp.$1);
    if (navigator.appVersion.indexOf('MSIE 10') != -1) iev = 10;
    if (trident && rv != -1) iev = 11;

    return iev;
  };

  var EaseInQuad = function(t) {
    if (t < 0) t = 0;
    if (t > 1) t = 1;
    return t * t;
  };

  var EaseOutQuad = function(t) {
    if (t < 0) t = 0;
    if (t > 1) t = 1;
    return t * (2 - t);
  };

  var EaseInOutQuad = function(t) {
    if (t < 0) t = 0;
    if (t > 1) t = 1;
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  };

  var EaseInOutCubic = function(t) {
    if (t < 0) t = 0;
    if (t > 1) t = 1;
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  };

  var SetupClicks = function() {
    $('.waveplayer_container')
      .off('mouseenter mousemove')
      .on('mouseenter mousemove', function(e) {
        clearTimeout(mouseOverTimeout);
        $('.waveplayer_container').addClass('mouse_enter');
        if (!$('.waveplayer_container .progress_container').hasClass('full')) {
          mouseOverTimeout = setTimeout(function() {
            if (
              !$('.waveplayer_container .playback_quality_list_container').is(':visible') &&
              !$('.waveplayer_container .playback_volume_control_container').is(':visible')
            ) {
              $('.waveplayer_container').removeClass('mouse_enter');
            }
          }, 2000);
        }
      })
      .off('mouseleave')
      .on('mouseleave', function(e) {
        if (!$('.waveplayer_container .progress_container').hasClass('full')) {
          mouseOverTimeout = setTimeout(function() {
            if (
              !$('.waveplayer_container .playback_quality_list_container').is(':visible') &&
              !$('.waveplayer_container .playback_volume_control_container').is(':visible')
            ) {
              $('.waveplayer_container').removeClass('mouse_enter');
            }
          }, 2000);
        }
      })
      .off('contextmenu')
      .on('contextmenu', function(e) {
        e.preventDefault();

        /*
					var o = root.offset(),
							w = $(window),
							left = ev.clientX - o.left,
							t = ev.clientY - o.top + w.scrollTop();
					var menu = root.find('.fp-context-menu').css({
						 left: left + 'px',
						 top: t + 'px',
						 display: 'block'
					}).on('click', function(ev) {
						 ev.stopPropagation();
					});
					$('html').on('click.outsidemenu', function(ev) {
						 menu.hide();
						 $('html').off('click.outsidemenu');
					});*/
      });

    if (!obj.config.isTouch) {
      $('.waveplayer_container .progress_container')
        .off('mouseenter mousemove')
        .on('mouseenter mousemove', function(e) {
          clearTimeout(progressMouseoverTimeout);
          if (!isDraggingVolume && !isDrawingOnCanvas && !isGrabbingVR) {
            var progressObj = $('.waveplayer_container .progress_container');
            var xPos = e.pageX - progressObj.offset().left;
            if (xPos >= 0 && progressObj.width() > 0) {
              var timePos = (xPos / progressObj.width()) * videoPlayer.duration;
              if ($('.time_mouseover').length != 1 || $('.time_mouseover_line').length != 1) {
                $('.time_mouseover, .time_mouseover_line').remove();
                $("<div class='time_mouseover' />").appendTo(
                  $('.waveplayer_container .progress_container')
                ); /* .controlbar */
                $("<div class='time_mouseover_line' />").appendTo($('.waveplayer_container .progress_container'));
              }

              $('.time_mouseover')
                .html(ConvertSecondsToSMPTE(timePos + obj.playerSettings.startTime))
                .css(
                  'left',
                  (xPos / progressObj.width()) * progressObj.width() - 0.5 * $('.time_mouseover').outerWidth()
                ); /* .css("top", progressObj.position().top - $(".time_mouseover").outerHeight()); */
              $('.time_mouseover_line').css('left', (xPos / progressObj.width()) * progressObj.width());
            }
            progressObj.addClass('full');
          }
        })
        .off('mouseleave')
        .on('mouseleave', function(e) {
          progressMouseoverTimeout = setTimeout(function() {
            $('.waveplayer_container .progress_container').removeClass('full');
            $('.time_mouseover, .time_mouseover_line').remove();
          }, 250);
        });
    }

    $('.waveplayer_container .progress_container')
      .off('mousedown touchstart')
      .on('mousedown touchstart', function(e) {
        e.preventDefault();
        clearTimeout(progressMouseoverTimeout);

        isDraggingTimePosition = true;
        timeOfLastDragUpdate = timeOfDragStart = new Date().getTime();
        $('.waveplayer_container').addClass('dragging_time');
        MouseMove(e);

        $(document)
          .on('mousemove touchmove', function(e) {
            e.preventDefault();
            MouseMove(e);
          })
          .one('mouseup touchend', function(e) {
            e.preventDefault();
            isDraggingTimePosition = false;
            $('.waveplayer_container').removeClass('dragging_time');
            $(document).off('mousemove touchmove');
          });
      });

    $('.waveplayer_container .playback_play_pause')
      .off('click')
      .click(function(e) {
        obj.TogglePause();
      });

    var volumeMouseOutTimeout,
      volumeMouseHasLeft = false;
    $('.waveplayer_container .playback_volume')
      .off('mouseenter')
      .on('mouseenter', function(e) {
        if (isDrawingOnCanvas || isDraggingTimePosition || isGrabbingVR) {
          return;
        }

        $(this).addClass('active');
        clearTimeout(volumeMouseOutTimeout);
        volumeMouseHasLeft = false;

        /* hide playback quality and VR View Mode */
        $('.waveplayer_container .vr_view .vr_view_list_container').hide(obj.config.animationLength);
        $('.waveplayer_container .vr_view .vr_view_outline').removeClass('active');
        $('.waveplayer_container .playback_quality .playback_quality_list_container').hide(obj.config.animationLength);
        $('.waveplayer_container .playback_quality .playback_quality_outline').removeClass('active');

        $('.waveplayer .playback_volume_control_container')
          .show()
          .off('click')
          .click(function(e) {
            e.stopPropagation();
          });

        $('.waveplayer .volume_slider_holder').on('mousedown', function(e) {
          e.stopPropagation();
          isDraggingVolume = true;
          $('.waveplayer_container .media').css('cursor', 'pointer');

          $(document)
            .on('mousemove', function(e) {
              e.stopPropagation();
              if ($('.waveplayer .volume_slider_holder').height() > 0) {
                var pageY = e.pageY;
                var yPos =
                  1 -
                  (pageY - $('.waveplayer .volume_slider_holder').offset().top) /
                    $('.waveplayer .volume_slider_holder').height();
                obj.SetVolume(yPos);
              }
            })
            .one('mouseup', function(e) {
              $(this).off('mousemove');
              isDraggingVolume = false;
              $('.waveplayer_container .media').css('cursor', '');

              if ($('.waveplayer .volume_slider_holder').height() > 0) {
                var pageY = e.pageY;
                var yPos =
                  1 -
                  (pageY - $('.waveplayer .volume_slider_holder').offset().top) /
                    $('.waveplayer .volume_slider_holder').height();
                obj.SetVolume(yPos);
              }
              if (volumeMouseHasLeft) {
                clearTimeout(volumeMouseOutTimeout);
                volumeMouseOutTimeout = setTimeout(function() {
                  $('.waveplayer .volume_slider_holder, .waveplayer .playback_volume_control_container').off('click');
                  $('.waveplayer .playback_volume').removeClass('active');
                  $('.waveplayer .playback_volume_control_container').hide();
                }, 1000);
              }
            });
        });
      })
      .off('mouseleave')
      .on('mouseleave', function(e) {
        volumeMouseHasLeft = true;
        if (!isDraggingVolume) {
          $('.waveplayer .volume_slider_holder, .waveplayer .playback_volume_control_container').off('click');
          $('.waveplayer .playback_volume').removeClass('active');
          $('.waveplayer .playback_volume_control_container').hide();
        }
      });

    $('.waveplayer_container .playback_volume')
      .off('click')
      .click(function(e) {
        if (!isDraggingVolume) {
          obj.ToggleMute();
        }
      });

    $('.waveplayer_container .playback_loop')
      .off('click')
      .click(function(e) {
        obj.ToggleLoop();
      });
    $('.waveplayer_container .playback_title_safe')
      .off('click')
      .click(function(e) {
        obj.ToggleTitleSafe();
      });
    $('.waveplayer_container .playback_fullscreen')
      .off('click')
      .click(function(e) {
        obj.ToggleFullscreen();
      });

    $('.waveplayer_container .comment_point')
      .off('click')
      .click(function(e) {
        /* $(this).toggleClass("active");
		if($(this).hasClass("active")){
			$(".waveplayer_container").addClass("cursor_comment_point");
		} else {
			$(".waveplayer_container").removeClass("cursor_comment_point");
		}*/

        $(this).addClass('active');
        $('.waveplayer_container')
          .addClass('cursor_comment_point')
          .removeClass('cursor_comment_paint');
        $('.waveplayer_container .comment_paint, .waveplayer_container .hand_icon').removeClass('active');

        if (commentInEdit && commentInEdit['isDrawing']) {
          commentInEdit['drawingBase64'] = '';
          commentInEdit['isDrawing'] = false;
          ClearCommentCanvas();
          $('.waveplayer_container .comment_clear_button').addClass('disabled');
        }

        ShowCommentsAtCurrentTime();
      });
    $('.waveplayer_container .comment_paint')
      .off('click')
      .click(function(e) {
        /*$(this).toggleClass("active");
		if($(this).hasClass("active")){
			$(".waveplayer_container").addClass("cursor_comment_paint");
		} else {
			$(".waveplayer_container").removeClass("cursor_comment_paint");
		}*/

        $(this).addClass('active');
        $('.waveplayer_container')
          .addClass('cursor_comment_paint')
          .removeClass('cursor_comment_point');
        $('.waveplayer_container .comment_point, .waveplayer_container .hand_icon').removeClass('active');

        if (commentInEdit && commentInEdit['isDot']) {
          if (commentInEdit['dot']) {
            commentInEdit['dot'].remove();
          }
          commentInEdit['dot'] = null;
          commentInEdit['isDot'] = false;
          ClearCommentCanvas();
          $('.waveplayer_container .comment_clear_button').addClass('disabled');
        }

        ShowCommentsAtCurrentTime();
      });
    $('.waveplayer_container .hand_icon')
      .off('click')
      .click(function(e) {
        $(this).addClass('active');
        $('.waveplayer_container').removeClass('cursor_comment_paint');
        $('.waveplayer_container').removeClass('cursor_comment_point');
        $('.waveplayer_container .comment_point, .waveplayer_container .comment_paint').removeClass('active');
      });

    $('.waveplayer_container .comment_clear_button')
      .off('click')
      .click(function(e) {
        if (!$(this).hasClass('disabled')) {
          obj.CancelNewComment();
        }
      });

    $('.waveplayer_container .comment_color')
      .off('click')
      .click(function(e) {
        if ($('.waveplayer_container .comment_color_list_container').is(':visible')) {
          $('.waveplayer_container .comment_color_list_container').hide(obj.config.animationLength);
          $('.waveplayer_container .comment_color_outline').removeClass('active');
        } else {
          $('.waveplayer_container .comment_color_list_container').show(obj.config.animationLength);
          $('.waveplayer_container .comment_color_outline').addClass('active');
        }
      });

    if (!obj.config.isTouch) {
      var commentColorTimeout;

      $('.waveplayer_container .comment_color')
        .off('mouseenter')
        .on('mouseenter', function(e) {
          if (!isDraggingVolume && !isDrawingOnCanvas && !isDraggingTimePosition && !isGrabbingVR) {
            clearTimeout(commentColorTimeout);
            $('.waveplayer_container .comment_color_list_container').show(obj.config.animationLength);
            $('.waveplayer_container .comment_color_outline').addClass('active');
          }
        })
        .off('mouseleave')
        .on('mouseleave', function(e) {
          var list = $(this);

          commentColorTimeout = setTimeout(function() {
            list.find('.comment_color_list_container').hide(obj.config.animationLength);
            list.find('.comment_color_outline').removeClass('active');
          }, 750);
        });
    }

    $(window).on('keydown', KeydownHandler);
  };

  $(document).ready(function() {
    obj
      .addClass('waveplayer')
      .append(
        '\
      <div class="waveplayer_container no_select initial_controls">\
        <div class="playback_error" style="display: none;"></div>\
        <div class="playback_seeking" style="display: none;"><div class="spinner"></div></div>\
        <div class="media">\
          <div class="audio_line"></div>\
          <div class="title_safe" style="display: none;"></div>\
          <div class="media_comment_holder">\
            <div class="interaction_target"></div>\
            <canvas class="comment_canvas in_progress" width="800" height="450"></canvas>\
            <canvas class="comment_canvas done" width="800" height="450"></canvas>\
					</div>\
          <canvas class="vr_render_canvas" style="display: none;" ></canvas>\
				</div>\
             <div class="controls">\
          <div class="on_screen_controls">\
					</div>\
          <div class="comment_controlbar">\
            <div class="button_container">\
              <div class="button_container_left">\
                <div class="control_button hand_icon active" title="Select the hand icon to move around in 360 degrees" style="display: none;"></div>\
                <div class="control_button comment_point" title="With this tool, click on the media to leave a point-based comment"></div>\
                <div class="control_button comment_paint" title="With this tool, click and draw on the media to leave a drawing-based comment"></div>\
                <div class="control_button comment_color" title="Choose what color the comment dot or paint should be">\
                  <div class="comment_color_outline">\
                    <div class="current_comment_color"><div class="comment_color_option" style="background-color: ' +
          obj.config.commentColorOptions[obj.config.commentColor] +
          ';"></div></div>\
                    <div class="comment_color_list_container">\
                      <ul class="comment_color_list">\
											</ul>\
										</div>\
									</div>\
								</div>\
                <div class="control_button comment_clear_holder">\
                  <div class="comment_clear_button disabled">Cancel</div>\
								</div>\
							</div>\
              <div class="button_container_middle">\
                <div class="control_button comment_message"></div>\
							</div>\
						</div>\
					</div>\
          <div class="controlbar">\
            <div class="button_container">\
              <div class="button_container_middle">\
                <div class="control_button key_message"></div>\
							</div>\
              <div class="button_container_right">\
                <div class="control_button playback_quality" title="Select the playback quality">\
                  <div class="playback_quality_outline">\
                    <div class="playback_quality_list_container">\
                      <ul class="playback_quality_list"></ul>\
										</div>\
                    <div class="current_playback_quality"></div>\
									</div>\
								</div>\
                <div class="control_button vr_view" title="Select the VR view">\
                  <div class="vr_view_outline">\
                    <div class="vr_view_list_container">\
                      <ul class="vr_view_list"></ul>\
										</div>\
                    <div class="current_vr_view"></div>\
									</div>\
								</div>\
                <div class="control_button playback_title_safe" title="Show or hide grid"></div>\
                <div class="control_button playback_fullscreen" title="Go fullscreen"></div>\
							</div>\
						</div>\
					</div>\
        <div class="system_message"></div>\
				</div>\
			</div>\
	        '
      );

    for (var c = 0; c < obj.config.commentColorOptions.length; c++) {
      $('<li class="' + c + '"></li>')
        .appendTo($('.waveplayer_container .comment_color .comment_color_list'))
        .on('click', function(e) {
          obj.config.commentColor = $(this).attr('class'); /*  .split(' ')[1]  */
          $('.waveplayer_container .comment_color .current_comment_color .comment_color_option').css(
            'background-color',
            obj.config.commentColorOptions[obj.config.commentColor]
          );
        })
        .append(
          $(
            '<div class="comment_color_option" style="background-color: ' +
              obj.config.commentColorOptions[c] +
              ';"></div>'
          )
        );
    }

    key_message = $('.waveplayer_container .controls .key_message');
    key_message.html('<p>' + obj.playerSettings.keyMsgStr + '</p>');
    if (obj.config.isTouch) {
      key_message.addClass('disabled').hide();
    }

    $('.waveplayer_container .controls .comment_message').html('<p>' + obj.playerSettings.commentMsgStr + '</p>');

    obj.config.isIE = GetIEVersion() > 0 ? true : false;
    obj.config.enableVR =
      !obj.config.isIE &&
      !obj.config.isIEMobile &&
      !obj.config.isiOS &&
      DetectWebGLContext() === true; /* DetectWebGLContext() !== null */

    obj.playerSettings.fileType = String(obj.playerSettings.fileType).toLowerCase();

    obj.ShowControls(obj.playerSettings.alwaysShowControls);
    window.ARGS.activeTab == 'ASSETS' || window.ARGS.detail == 'true' || obj.playerSettings.isCompareMode
      ? null
      : obj.ShowComments(obj.playerSettings.enableComments);
    obj.SetPlaybackQuality(obj.playerSettings.quality, obj.playerSettings.autostart);
    //	obj.SetVolume(obj.playerSettings.volume);
  });

  return this;
};
